// src/LogicSearch/kimKinhDich.js
// Logic phân tích số căn cước theo "bát cực linh số" (cập nhật)
// - Ưu tiên: nếu cặp nằm trong cùng group -> lấy năng lượng của group
// - build concat từ GROUPS (không đơn thuần lặp từng chữ số) để đảm bảo cặp con kế thừa group

// -----------------------------
// 1) MAPPING 2-digit / 3-digit / 5-digit (rút từ dữ liệu bạn cung cấp)
// -----------------------------
import solarlunar from 'solarlunar';
export const TWO_DIGIT_MAP = {
  11: 'Phục Vị',
  22: 'Phục Vị',
  33: 'Phục Vị',
  44: 'Phục Vị',
  55: 'Phục Vị',
  66: 'Phục Vị',
  77: 'Phục Vị',
  88: 'Phục Vị',
  99: 'Phục Vị',
  12: 'Tuyệt Mệnh',
  21: 'Tuyệt Mệnh',
  69: 'Tuyệt Mệnh',
  96: 'Tuyệt Mệnh',
  48: 'Tuyệt Mệnh',
  84: 'Tuyệt Mệnh',
  37: 'Tuyệt Mệnh',
  73: 'Tuyệt Mệnh',
  13: 'Thiên Y',
  31: 'Thiên Y',
  68: 'Thiên Y',
  86: 'Thiên Y',
  49: 'Thiên Y',
  94: 'Thiên Y',
  27: 'Thiên Y',
  72: 'Thiên Y',
  14: 'Sinh Khí',
  41: 'Sinh Khí',
  67: 'Sinh Khí',
  76: 'Sinh Khí',
  39: 'Sinh Khí',
  93: 'Sinh Khí',
  28: 'Sinh Khí',
  82: 'Sinh Khí',
  16: 'Lục Sát',
  61: 'Lục Sát',
  47: 'Lục Sát',
  74: 'Lục Sát',
  38: 'Lục Sát',
  83: 'Lục Sát',
  29: 'Lục Sát',
  92: 'Lục Sát',
  17: 'Họa Hại',
  71: 'Họa Hại',
  89: 'Họa Hại',
  98: 'Họa Hại',
  46: 'Họa Hại',
  64: 'Họa Hại',
  23: 'Họa Hại',
  32: 'Họa Hại',
  18: 'Ngũ Quỷ',
  81: 'Ngũ Quỷ',
  79: 'Ngũ Quỷ',
  97: 'Ngũ Quỷ',
  36: 'Ngũ Quỷ',
  63: 'Ngũ Quỷ',
  24: 'Ngũ Quỷ',
  42: 'Ngũ Quỷ',
  19: 'Diên Niên',
  91: 'Diên Niên',
  78: 'Diên Niên',
  87: 'Diên Niên',
  34: 'Diên Niên',
  43: 'Diên Niên',
  26: 'Diên Niên',
  62: 'Diên Niên',
};

export const tomtatDuNien = {
  'Sinh Khí': {
    tohop: '14,41,67,76,39,93,28,82',
    yes: 'Tài lộc dồi dào, sự nghiệp thăng tiến, sức khỏe tốt, quý nhân phù trợ, cuộc sống thuận lợi.',
    no: 'Thiếu tài lộc, sự nghiệp chậm phát triển, ít may mắn và khó được người khác giúp đỡ.',
  },
  'Thiên Y': {
    tohop: '13,31,68,86,49,94,27,72',
    yes: 'Bình an, sức khỏe, quý nhân hỗ trợ, dễ hóa giải tai ương, gặp nhiều may mắn.',
    no: 'Tài vận kém, vất vả trong công việc, hôn nhân không thuận hòa.',
  },
  'Diên Niên': {
    tohop: '19,91,78,87,34,43,26,62',
    yes: 'Gia đạo yên ấm, quan hệ bền lâu, công việc ổn định, ít sóng gió.',
    no: 'Quan hệ dễ mâu thuẫn, gia đạo thiếu hòa hợp, công việc thiếu ổn định.',
  },
  'Phục Vị': {
    tohop: '11,22,33,44,66,77,88,99',
    yes: 'An yên nội tâm, kiên định, lợi cho học hành và thi cử, vững vàng trong cuộc sống.',
    no: 'Tâm lý dễ dao động, thiếu ổn định, học hành hay công việc khó thành công.',
  },
  'Họa Hại': {
    tohop: '23,32,17,71,46,64,89,98',
    yes: 'Nhiều rắc rối nhỏ, tiểu nhân quấy phá, thường gặp phiền toái.',
    no: 'Ít bị vướng thị phi, giảm rủi ro nhỏ, cuộc sống nhẹ nhõm hơn.',
  },
  'Lục Sát': {
    tohop: '16,61,47,74,38,83,29,92',
    yes: 'Tranh chấp, tình cảm trắc trở, dễ gặp rủi ro trong công việc và xã hội.',
    no: 'Quan hệ ổn định hơn, ít tranh cãi, tình cảm suôn sẻ hơn.',
  },
  'Ngũ Quỷ': {
    tohop: '24,42,36,63,79,97,18,81',
    yes: 'Nhiều rắc rối, mất mát, thị phi, hao tổn cả tài chính lẫn tinh thần.',
    no: 'Ít gặp phiền toái, giảm rủi ro, hạn chế mất mát không đáng có.',
  },
  'Tuyệt Mệnh': {
    tohop: '12,21,69,96,37,73,48,84',
    yes: 'Bệnh tật, hao tài nặng, dễ gặp thất bại lớn trong cuộc sống.',
    no: 'Sức khỏe ổn định hơn, giảm tổn thất, ít nguy cơ thất bại nghiêm trọng.',
  },
};

export const TongKetSoDuoi = {
  'Thiên Y':
    'Nguồn năng lượng này mang đến sự bình an, và sức khỏe. Chủ nhân có quý nhân phù trợ, rất dễ hóa cải các vấn nạn, dễ gặp được may mắn, dễ là quý nhân của người khác.\n\nNăng lượng này dễ mang cơ hội làm ông chủ- bà chủ, khoáng đạt, vượng khí, thông minh, thiện lương, thích giúp đỡ người khác.\n\nDễ kiếm tiền, tích trữ được của cải, có trực giác (giác quan thứ 6 rất tốt), dễ thể hiện tình cảm và đón nhận tình cảm, nhiệt thành, chiêu cảm tài lộc tốt.\n\nHôn nhân: Được trợ rất tốt. Nam và nữ nên có tối thiểu 1 cặp trong dãy số.',
  'Tuyệt Mệnh':
    'Nguồn năng lượng này mang đến cho người sở hữu một sức hút đặc biệt với thế giới tài chính. Họ thường thể hiện sự liều lĩnh, ham ăn thua và nhạy bén với các cơ hội đầu tư. Điều này có thể giúp họ kiếm được nhiều tiền từ các lĩnh vực như BĐS, chứng khoán, tiền điện tử và các hình thức kinh doanh khác.\n\nTuy nhiên, nếu không được kiểm soát tốt, năng lượng này cũng có thể dẫn đến những hậu quả tiêu cực như gây nghiện cờ bạc, mất tiền và ảnh hưởng đến sức khỏe.\n\nNhững người sở hữu nguồn năng lượng này nên cân nhắc kỹ lưỡng trước khi đưa ra các quyết định đầu tư và học hỏi kinh nghiệm từ những người đi trước để giảm thiểu rủi ro.\n\nNếu nằm ở vị trí đẹp: Rất có lộc đầu tư, tích lũy được tài sản (BĐS, vàng).\n\nNếu ở vị trí xấu, bị phá: Thường mất tiền liên tục, bạo phát- bạo tàn, dễ bị lừa tiền, phá sản, bị lợi dung, đầu tư đâu mất đó, cho vay không đòi được.\n\nPhản ứng nhanh nhạy, nhưng dễ liên đới pháp lý, dễ bị kích động bởi các cơ hội kinh doanh, thích hơn thua, dính kiện cáo (thua kiện)\n\nHôn nhân: Thường thích tán dương, khen ngợi, cổ vũ, dễ mất cảm xúc và dễ bị lục đục vì vấn đề tài chính.\n\nSức khỏe: Nếu bị phá dễ mệt mỏi, suy nhược, thường chiêu cảm những bệnh liên quan đến tạng (gan-thận-mật-tim), tiểu đường, khớp, thậm chí là dễ có bệnh nền dính đến K, chiêu cảm.',
  'Sinh Khí':
    'Nguồn năng lượng này đại diện cho may mắn, quý nhân, tài lộc, các mối quan hệ xã hội, vượng khí, sức khỏe tốt, an vui, an nhàn, năng lượng tốt, vui vẻ, tốt bụng, ngoại giao được lòng người.\n\nBao giao- hào phóng, thích tiêu tiền cho các mối quan hệ (người thân- mối quan hệ xã hội), có nhiều mối quan hệ tốt.\n\nTừ trường này thì nên có 1-2 cặp trong dãy số, nên thiết kế cho người sức khỏe yếu, người già.',
  'Lục Sát':
    'Năng lượng này thường mang đến sự ưa thích cái đẹp, nhạy cảm với cái đẹp - thẩm mỹ. Có năng khiếu về mỹ thuật, giao tiếp khéo léo, sắc bén, bậc thầy ngoại giao. thu hút, hấp dẫn và  bị hấp dẫn với người khác, tinh tế.\n\nRất là chú trọng về cảm xúc, trọng tình trọng nghĩa, sức chịu đựng áp lực kép, dễ rung động- nhạy cảm, đa sầu đa cảm, cảm xúc dễ bị chi phối. \n\nNếu ở vị trí xấu: Dễ bị lụy tình, an phận, thiếu sức chiến đấu, dễ tiêu tiền cho các mối quan hệ tình cảm, hay chú ý về diện mạo bên ngoài.\n\nGiỏi hoặc có năng khiếu các môn: Cầm - kỳ - thi - họa, giọng hay, rất dễ có cảm tình với người khác giới, quản lý tiền bạc yếu.\n\nHôn nhân: Nếu được kết cấu thì rất mặn nồng, được yêu chiều. Nhưng nếu bị phá thì dễ có người thứ 3, năng lượng bị phân tán, nam giới (dễ ngoại tình), lục đục, hôn nhân gặp vấn đề, tình cảm chật vật.\n\nSức khỏe: Nếu ở vị trí xấu, thường dễ bị các bệnh lý về da liễu (Mề đay, nấm, viêm nang lông...), u uất tinh thần, dễ stress. Riêng nữ giới lưu ý: (Dễ mắc các bệnh liên quan đến phụ khoa, nội tiết tố (u, xơ, nang....) hoặc các bệnh truyền nhiễm.\n\nLưu ý: Đàn ông không nên có từ trường này. Nữ giới nên có nhưng phải được kết cấu cẩn thận',
  'Họa Hại':
    'Nguồn năng lượng này mang đến khả năng ăn nói lưu loát, giao tiếp tốt, thích ngoại giao và ăn nói lịch thiệp. Có thế mạnh trong môi trường làm việc cần giao tiếp , ăn nói.\n\nDễ và có xu hướng làm các công việc: tư vấn- bán hàng, đại diện thương hiệu, đàm phán, giảng dạy (giáo viên, coaching, trainner), nhà hàng...\n\nTính cách: Bộc trực, thẳng tính, nóng nảy, xu hướng nói nhiều, dễ gây ra thị phi, sỹ diện cao, cái tôi lớn, dễ có tiểu nhân đâm chọc sau lưng, hay gây bất hòa, tranh cãi.\n\nNếu ở vị trí xấu: Nóng nảy, dễ gây ra kiện tụng, mất tiền, mất tình cảm, dễ bị nói xấu, đơm điều- đặt chuyện, vạ lây, liên đới, tiêu tán tài sản rất nhanh, hay bị kích động, (thường quý nhân sẽ biến thành tiểu nhân)\n\nTiền bạc: Kiếm được tiền nhanh- Nhưng cũng mất rất nhanh, thường mất tiền vì thể diện- thể diện- cái tôi, không chịu được đả kích, cuộc sống thị phi- phức tạp.\n\nHôn nhân: Thường Dùng số này 3-5 năm đầu rất là mặn nồng- tốt đẹp, sau thì thường bị thị phi tác động (hiểu lầm, khắc khẩu, rạn nứt) Sức khỏe ở vị trí xấu bị phá: Thường chiêu cảm những bệnh lý: Các bệnh liên quan đến tai-mũi- hầu- họng- phổi- phế quản, viêm mũi dị ứng, viêm xoang, sưng họng, cảm cúm, hút khí- hụt hơi...',
  'Ngũ Quỷ':
    'Nguồn năng lượng này ban tặng cho người sở hữu một trí tuệ sắc sảo và khả năng tư duy logic vượt trội. Họ thường là những người nhạy bén, đa nghi và có một tâm hồn phức tạp. Điều này giúp họ xuất sắc trong các lĩnh vực đòi hỏi sự tập trung cao độ như CNTT, chiến lược và nghiên cứu.\n\nTuy nhiên, chính vì sự nhạy cảm và tò mò quá mức, họ dễ bị cuốn vào những công việc mờ ám hoặc những bí ẩn chưa được khám phá.\n\nNhững người này thường có thu nhập cao nhưng cũng đối mặt với nhiều áp lực và rủi ro.\n\nThường thích nghiên cứu huyền học, tâm linh, những thứ phức tạp, dễ được mọi người tôn trọng, hỏi ý kiến.\n\nCó thể thiết kế cho học sinh - sinh viên.\n\nNếu ở vị trí xấu: Không bao giờ có quý nhân- không giữ được quý nhân, bạo phát- bạo tàn, hay gặp xui rủi, dễ dính kiện cáo, lo âu, tiêu cực, suy nhược cơ thể, khó ngủ. Nếu như ở vị trí đẹp: Có khả năng nghiên cứu, được tôn trọng, dễ kiếm tiền.\n\nHôn nhân: Dễ tạo ra cảm giác bất an với bạn đời, hay nghi ngờ, hiểu lầm trong hôn nhân, trục trặc, thường có vấn đề liên quan đến tinh thần, tan vỡ.\n\nSức khỏe: Thường chiêu cảm các bệnh lý, vấn nạn cụ thể như: Dễ mắc các bệnh liên quan đến thần kinh (đầu nửa đầu, đau thái dương, tắc nghẽn dây thần kinh, thần kinh tọa, tuần hoàn máu...) tim mạch (huyết áp, suy nhược, yếu khí..), dễ chiêu cảm các vấn đề liên quan đế xô xát, tai nạn, máu huyết, lao ngục...',
  'Diên Niên':
    'Nguồn năng lượng này thường mang đến sự đảm trách các công việc liên quan đến quản lý, lãnh đạo, có uy quyền, dễ được tín nhiệm, trao quyền, dễ nắm tài chính trong gia đình (có quyền kiểm soát), làm chủ gia đình.\n\nVì vậy, nên thường gánh vác rất nhiều trọng trách trong cuộc sống, chăm chỉ, có lập trường, có sự thuyết phục, quản lý tài chính tốt.\n\nCó trách nhiệm cao, trọng chữ tín, tâm địa thiện lương, thích bảo vệ kẻ yếu, trượng nghĩa, coi trọng danh dự. Có tính kiên trì, sức chịu đựng áp lực tốt.\n\nLưu ý: Phụ nữ thì không nên có nhiều từ trường này nếu không chú trọng sự nghiệp, nếu có thì cần được kết cấu (kích cơ hội, thăng tiến sự nghiệp, quý nhân)\n\nNam giới thì nên có 1 đến 2 cặp để hỗ trợ cho sự nghiệp.',
};

export const NANG_LUONG_INFO = {
  'Thiên Y': { name: 'Thiên Y', nguHanh: 'Thổ', lug: 'tho' },
  'Sinh Khí': { name: 'Sinh Khí', nguHanh: 'Mộc', lug: 'moc' },
  'Diên Niên': { name: 'Diên Niên', nguHanh: 'Kim', lug: 'kim' },
  'Phục Vị': { name: 'Phục Vị', nguHanh: 'Mộc', lug: 'moc' },
  'Tuyệt Mệnh': { name: 'Tuyệt Mệnh', nguHanh: 'Hỏa', lug: 'hoa' },
  'Ngũ Quỷ': { name: 'Ngũ Quỷ', nguHanh: 'Hỏa', lug: 'hoa' },
  'Lục Sát': { name: 'Lục Sát', nguHanh: 'Thủy', lug: 'thuy' },
  'Họa Hại': { name: 'Họa Hại', nguHanh: 'Thổ', lug: 'tho' },
};

// =============================
// HÀM TỰ ĐỘNG BỔ SUNG nl1 & nl2
// =============================
function enrichEnergyCombinations(combos) {
  const enriched = {};

  for (const [key, value] of Object.entries(combos)) {
    const [e1, e2] = key.split('+').map((s) => s.trim());

    enriched[key] = {
      ...value,
      nl1: NANG_LUONG_INFO[e1] || null,
      nl2: NANG_LUONG_INFO[e2] || null,
    };
  }

  return enriched;
}

export const ENERGY_COMBINATIONS = {
  // ===== Thiên Y + ... =====
  'Thiên Y + Thiên Y': {
    general:
      'Hai Thiên Y kết hợp tạo trường năng lượng chữa lành mạnh mẽ, mang lại bình an, phúc đức và khả năng hồi phục. Người mang tổ hợp này thường được quý nhân phù trợ và có đời sống gia đình ổn định.',
    taiChinh:
      'Thu nhập ổn định, tiền vào đều. Không dễ gặp sóng gió tài chính lớn, phù hợp nghề chăm sóc, giáo dục, y tế. Mặt trái: ít cơ hội bùng nổ tài sản nếu thiếu tham vọng.',
    honNhan:
      'Gia đạo yên ấm, vợ chồng biết nhường nhịn. Tuy nhiên dễ rơi vào thói quen an phận, thiếu lửa nếu không vun vén.',
    sucKhoe: 'Sức khỏe được bảo hộ, dễ hồi phục sau bệnh. Khuyến cáo khám định kỳ, tránh chủ quan bệnh nhẹ kéo dài.',
    phapLy: 'Ít vướng kiện tụng; quan hệ xã hội ôn hòa. Mặt trái: đôi khi dễ bị người khác lợi dụng sự mềm mỏng.',
    khuyenNghi:
      'Phát triển nghề nghiệp hướng phục vụ, kết hợp rèn tính quyết đoán. Duy trì vận động, khám sức khỏe định kỳ.',
  },

  'Thiên Y + Sinh Khí': {
    general:
      'Kết hợp cát lợi: Thiên Y bảo vệ sức khỏe, Sinh Khí mang tới năng lượng phát triển. Người có tổ hợp này thường có sức khỏe, may mắn và nhiều cơ hội tài lộc.',
    taiChinh:
      'Khả năng tăng thu nhập cao, thuận hợp cho buôn bán, đầu tư dài hạn. Rủi ro: tham vọng thái quá dẫn tới đầu tư mạo hiểm.',
    honNhan: 'Quan hệ ấm áp, gia đình tương đối đầy đủ. Mặt trái: công việc có thể chiếm thời gian chăm sóc gia đình.',
    sucKhoe: 'Thể lực tốt, ít bệnh nặng. Cần cân bằng nghỉ ngơi khi làm việc quá tải.',
    phapLy: 'Ít rắc rối pháp lý, quan hệ xã hội thuận lợi. Tránh hành xử chủ quan khi được ưu ái.',
    khuyenNghi: 'Tận dụng thời cơ phát triển, nhưng quản trị rủi ro nghiêm túc, giữ lịch khám sức khỏe.',
  },

  'Thiên Y + Diên Niên': {
    general:
      'Thiên Y kết hợp Diên Niên đem đến ổn định dài hạn: gia đạo, công việc và sức khỏe đều có nền tảng. Thích hợp xây dựng cuộc sống bền vững.',
    taiChinh: 'Tài chính tích lũy, phát triển chậm mà chắc. Mặt trái: ít cơ hội bứt phá nhanh.',
    honNhan: 'Hôn nhân bền vững, quan hệ họ hàng tốt. Tránh bảo thủ làm yếu tính sáng tạo trong gia đình.',
    sucKhoe: 'Ít bệnh nặng; chú trọng phòng ngừa bệnh mãn tính khi tuổi cao.',
    phapLy: 'Ít kiện tụng, dễ hòa giải. Mặt cần đề phòng: trì trệ trong việc xử lý vấn đề pháp lý cấp bách.',
    khuyenNghi: 'Đầu tư dài hạn, chăm sóc sức khỏe phòng ngừa, giữ tinh thần linh hoạt.',
  },

  'Thiên Y + Phục Vị': {
    general:
      'Phục Vị trấn an Thiên Y: năng lượng tĩnh, an yên, thích hợp tu dưỡng, phục hồi. Người có tổ hợp này thường nội tâm vững vàng nhưng có thể thiếu nhu cầu bứt phá.',
    taiChinh:
      'Thu nhập ổn, không bùng nổ. Phù hợp nghề tư vấn, trị liệu. Hạn chế: khó thích hợp với mô hình kinh doanh mạo hiểm.',
    honNhan: 'Quan hệ gia đình êm đềm, ít mâu thuẫn lớn. Nhưng đôi khi thiếu lửa, cần chủ động tạo không khí.',
    sucKhoe: 'Tốt nếu duy trì thói quen lành mạnh; rủi ro: stress âm ỉ, tiêu hóa kém khi lo lắng.',
    phapLy: 'Ít rắc rối pháp lý; giải quyết theo cách hòa giải. Hạn chế: dễ bị lợi dụng nếu quá nhún nhường.',
    khuyenNghi: 'Thực hành thiền, nghỉ ngơi, cải thiện giao tiếp để tránh cô lập; rèn kỹ năng tự chăm lo.',
  },

  'Thiên Y + Tuyệt Mệnh': {
    general:
      'Tổ hợp ở thế đối nghịch: Thiên Y chữa lành, Tuyệt Mệnh gây cắt đứt. Năng lượng dễ dẫn đến biến động lớn, cảnh báo cẩn trọng trong nhiều mặt đời sống.',
    taiChinh:
      'Rủi ro tài chính cao, dễ hao tài do quyết định vội vàng. Tuy nhiên có khả năng phục hồi nếu biết bảo toàn vốn.',
    honNhan: 'Căng thẳng, xung đột có thể xảy ra; cần can thiệp tư vấn khi mâu thuẫn kéo dài.',
    sucKhoe:
      'Nguy cơ bệnh nặng hoặc tình trạng sức khỏe xấu hơn bình thường; cần thăm khám khi có dấu hiệu bất thường.',
    phapLy: 'Có thể dính kiện tụng hoặc thị phi lớn; luật sư, giấy tờ minh bạch là cần thiết.',
    khuyenNghi: 'Tạm dừng quyết định lớn, củng cố quỹ dự phòng, chăm sóc sức khỏe và tìm chuyên gia hỗ trợ.',
  },

  'Thiên Y + Ngũ Quỷ': {
    general:
      'Thiên Y (bảo vệ) gặp Ngũ Quỷ (xáo trộn): năng lượng hỗn hợp, có cơ may nhưng tiềm ẩn rủi ro tinh thần và xã hội.',
    taiChinh: 'Thu nhập thất thường; có lúc bội thu, có lúc hao hụt. Tránh vay mượn và cho người không rõ uy tín.',
    honNhan: 'Tình cảm dễ nghi kỵ, thay đổi. Nếu biết giao tiếp cởi mở có thể hóa giải nhiều vấn đề.',
    sucKhoe: 'Dễ bị rối loạn giấc ngủ, stress, các vấn đề tiêu hóa. Nên chú trọng chăm sóc tinh thần.',
    phapLy: 'Dễ dính thị phi, kiện cáo nhỏ; chuẩn bị chứng từ khi giao dịch.',
    khuyenNghi: 'Hạn chế hợp tác mơ hồ, lập quỹ dự phòng, tìm hỗ trợ tâm lý khi cần.',
  },

  'Thiên Y + Lục Sát': {
    general:
      'Thiên Y gặp Lục Sát tạo ma sát: mối quan hệ và quyền lợi có nguy cơ vỡ nứt nếu không thận trọng; năng lượng dễ gây tổn thất nhỏ lặp lại.',
    taiChinh: 'Dễ mất tiền vì tranh chấp, bạn bè, đối tác. Nên giữ sổ sách minh bạch.',
    honNhan: 'Xung đột tình cảm, hiểu lầm. Cần giao tiếp trực tiếp, tránh hành động bốc đồng.',
    sucKhoe: 'Stress, vấn đề cơ-xương do lao động, căng thẳng. Chú ý an toàn cá nhân.',
    phapLy: 'Rủi ro tranh chấp hợp đồng, quyền lợi; chuẩn bị pháp lý là quan trọng.',
    khuyenNghi: 'Chuẩn hóa hợp đồng, tránh hợp tác vội, tăng cường bảo hiểm và pháp lý.',
  },

  'Thiên Y + Họa Hại': {
    general:
      'Thiên Y gặp Họa Hại: hay gặp phiền toái, thị phi, tốn kém cho hình thức. Năng lượng dễ gây hao tổn thời gian, tiền bạc cho việc xã giao.',
    taiChinh: 'Chi phí xã giao lớn, dễ tiêu tiền cho sĩ diện. Cần kiểm soát chi tiêu.',
    honNhan: 'Hiểu lầm nhỏ có thể leo thang nếu không xử lý khéo. Cần nhún nhường và xin lỗi khi cần.',
    sucKhoe: 'Dễ cảm cúm, dị ứng, mệt mỏi; chăm sóc sức khỏe cơ bản là cần thiết.',
    phapLy: 'Chủ yếu là thị phi, ít kiện tụng nặng; xử lý truyền thông và bằng chứng để tránh rắc rối.',
    khuyenNghi: 'Tiết chế chi tiêu, giữ lời nói nhẹ nhàng, xử lý xung đột bằng cách hòa giải.',
  },

  // ===== Sinh Khí + ... =====
  'Sinh Khí + Thiên Y': {
    general:
      'Sinh Khí dẫn đường, Thiên Y bảo vệ: tổ hợp mang tính khởi sắc nhưng có yếu tố phải giữ gìn sức khỏe khi lao lực.',
    taiChinh: 'Cơ hội kiếm tiền qua quan hệ, công việc năng động; nên quản trị tài chính để tránh tiêu xài bốc đồng.',
    honNhan: 'Quan hệ gia đình ấm áp, dễ có trợ lực từ người thân và quý nhân.',
    sucKhoe: 'Sức khỏe tổng thể tốt nhưng lưu ý nghỉ ngơi khi dồn lực cao; tránh kiệt sức.',
    phapLy: 'Quan hệ xã hội tốt giúp giảm rủi ro pháp lý. Tuy nhiên vẫn cần minh bạch trong giao dịch.',
    khuyenNghi: 'Tận dụng cơ hội, xây dựng mối quan hệ bền vững, nhưng nghỉ ngơi khoa học.',
  },

  'Sinh Khí + Sinh Khí': {
    general:
      'Sinh Khí nhân đôi: năng lượng phát triển rất mạnh — thuận lợi cho khởi nghiệp, bứt phá và mở rộng. Cần quản trị tăng trưởng.',
    taiChinh: 'Thu nhập tăng nhanh, khả năng nhân dòng tiền tốt. Rủi ro: thiếu hệ thống quản trị dẫn tới vỡ quy mô.',
    honNhan: 'Quan hệ sôi nổi, đôi khi bận rộn nên thiếu thời gian cho gia đình.',
    sucKhoe: 'Thể lực tốt nhưng dễ quá tải; cần phân bổ thời gian nghỉ ngơi.',
    phapLy: 'Ít rắc rối pháp lý nếu có hệ thống; khi mở rộng cần chuẩn hoá pháp lý kịp thời.',
    khuyenNghi: 'Xây hệ thống quản trị, chia sẻ trách nhiệm, dự phòng tài chính.',
  },

  'Sinh Khí + Diên Niên': {
    general:
      'Sinh Khí trên nền Diên Niên tạo điều kiện phát triển bền vững: tiến lên mà có nền tảng, tốt cho thăng tiến và học hành.',
    taiChinh: 'Thu nhập ổn định và có triển vọng lâu dài; lợi cho đầu tư an toàn.',
    honNhan: 'Gia đình ủng hộ, con cái có nền tảng tốt; phụ nữ trong gia đình có thể là trợ lực lớn.',
    sucKhoe: 'Ổn, phù hợp lối sống cân bằng; chú ý xương khớp khi tuổi cao.',
    phapLy: 'Quan hệ xã hội thuận lợi, ít tranh chấp. Hòa giải hiệu quả khi có mâu thuẫn.',
    khuyenNghi: 'Kiên trì theo lộ trình nghề nghiệp, đầu tư dài hạn, nâng cao năng lực lãnh đạo.',
  },

  'Sinh Khí + Phục Vị': {
    general:
      'Sinh Khí được Phục Vị trấn: năng lượng tăng trưởng nhưng có tính kỷ luật, phù hợp cho nghề chuyên môn và học thuật.',
    taiChinh: 'Thu nhập ổn định từ nghề chuyên môn; không hợp trading tần suất cao.',
    honNhan: 'Gia đình tôn trọng công việc, mối quan hệ hỗ trợ lẫn nhau.',
    sucKhoe: 'Thể trạng tốt nhưng dễ mất ngủ vì lo việc; cần chăm sóc giấc ngủ.',
    phapLy: 'Ít rắc rối pháp lý nếu tuân thủ, con đường thăng tiến rõ ràng.',
    khuyenNghi: 'Đầu tư cho kỹ năng chuyên môn, cân bằng công việc và gia đình.',
  },

  'Sinh Khí + Tuyệt Mệnh': {
    general:
      'Sinh Khí gặp Tuyệt Mệnh tạo mâu thuẫn: tham vọng lớn nhưng rủi ro cao — cần thận trọng với các hành động mang tính liều lĩnh.',
    taiChinh: 'Có cơ hội lợi nhuận cao nhưng rủi ro phá sản nếu dùng đòn bẩy. Tránh vay mượn đòn bẩy quá tay.',
    honNhan: 'Áp lực tài chính dễ gây xung đột gia đình; cần đồng thuận trước quyết định lớn.',
    sucKhoe: 'Dễ suy kiệt nếu lao lực quá mức; khám định kỳ nếu thấy mệt kéo dài.',
    phapLy: 'Nguy cơ vướng pháp lý trong các dự án rủi ro; minh bạch hợp đồng.',
    khuyenNghi: 'Giảm bớt rủi ro, thử nghiệm nhỏ trước khi quyết định lớn, có tư vấn chuyên môn.',
  },

  'Sinh Khí + Ngũ Quỷ': {
    general: 'Sinh Khí + Ngũ Quỷ: sáng tạo nhưng cảm xúc thất thường; có cơ hội nếu biết kỷ luật bản thân.',
    taiChinh: 'Thu nhập có thể đến từ ý tưởng sáng tạo; rủi ro nếu quản lý kém dễ thất thoát.',
    honNhan: 'Quan hệ nhiều cảm xúc, cần minh bạch để tránh hiểu lầm.',
    sucKhoe: 'Tinh thần dao động, dễ mất ngủ; phương pháp quản trị stress cần được áp dụng.',
    phapLy: 'Nguy cơ tranh chấp do lời nói, cần lưu chứng từ và cam kết.',
    khuyenNghi: 'Lập quy trình, test ý tưởng nhỏ, quản lý cảm xúc trước khi triển khai lớn.',
  },

  'Sinh Khí + Lục Sát': {
    general: 'Sinh Khí bị sát khí cản: có cơ hội nhưng dễ gặp đối đầu và bị lừa nếu thiếu tỉnh táo.',
    taiChinh: 'Cẩn trọng khi chọn đối tác, hợp tác mơ hồ dễ thua thiệt.',
    honNhan: 'Quan hệ có thể vui vẻ lúc đầu nhưng dễ nảy sinh mâu thuẫn do hiểu lầm.',
    sucKhoe: 'Căng thẳng, đau đầu, huyết áp do áp lực; đề phòng tai nạn nhỏ khi làm việc vội.',
    phapLy: 'Nguy cơ tranh chấp hợp đồng; giấy tờ cần rõ ràng.',
    khuyenNghi: 'Minh bạch hợp tác, chuẩn bị pháp lý, giảm tốc khi ra quyết định quan trọng.',
  },

  'Sinh Khí + Họa Hại': {
    general:
      'Sinh Khí + Họa Hại: cơ hội tồn tại nhưng có nhiều phiền toái; phù hợp kinh doanh nhỏ, dịch vụ hơn là đầu tư lớn.',
    taiChinh: 'Lợi nhưng phát sinh chi phí xã giao, marketing; cần quản trị chi phí tốt.',
    honNhan: 'Hiểu lầm nhỏ, xử lý nhanh sẽ qua; tránh để vấn đề tích tụ.',
    sucKhoe: 'Dễ mệt, dị ứng, mất ngủ thoáng; giữ lối sống lành mạnh.',
    phapLy: 'Chủ yếu thị phi; giữ bằng chứng giao dịch.',
    khuyenNghi: 'Kiểm soát chi phí, cải thiện truyền thông, tránh PR nóng khi danh tiếng yếu.',
  },

  // ===== Diên Niên + ... =====
  'Diên Niên + Thiên Y': {
    general:
      'Diên Niên + Thiên Y: nền tảng ổn định gặp năng lượng chữa lành — thích hợp chuyên nghiệp, quản lý và chăm sóc cộng đồng.',
    taiChinh: 'Quản lý tài chính tốt, kiếm tiền từ năng lực thực tế. Rủi ro: thụ động khi cơ hội cần quyết đoán.',
    honNhan: 'Gia đình ổn định, mối quan hệ bền vững. Đôi khi hơi thiếu đổi mới trong đời sống tình cảm.',
    sucKhoe: 'Ổn nếu phòng bệnh mãn tính, chú ý phòng ngừa.',
    phapLy: 'Ít tranh chấp, danh tiếng tốt. Nhưng cần chủ động khi có vấn đề pháp lý phát sinh.',
    khuyenNghi: 'Nâng cao chuyên môn, quản trị tài chính chắc, chủ động thích ứng thay đổi.',
  },

  'Diên Niên + Sinh Khí': {
    general: 'Diên Niên nền tảng + Sinh Khí phát triển: tốt cho thăng tiến, học hành và sự nghiệp bền vững.',
    taiChinh: 'Thu nhập ổn định, khả năng thăng tiến. Tuy nhiên tránh nóng vội trong đầu tư.',
    honNhan: 'Gia đình hỗ trợ, quan hệ hài hòa; phù hợp với môi trường học thuật và quản lý.',
    sucKhoe: 'Sức khỏe tương đối ổn; chú ý dinh dưỡng và vận động nhẹ.',
    phapLy: 'Quan hệ xã hội tốt, ít rắc rối pháp lý.',
    khuyenNghi: 'Bám sát lộ trình học tập/ sự nghiệp, đầu tư dài hạn có kế hoạch.',
  },

  'Diên Niên + Diên Niên': {
    general:
      'Diên Niên nhân đôi: cực kỳ ổn định — phù hợp làm chủ, quản lý tổ chức lâu dài. Năng lượng bền vững và chắc chắn.',
    taiChinh: 'Dòng tiền ổn, tiết kiệm tốt. Hạn chế: ít cơ hội đột phá nếu quá thận trọng.',
    honNhan: 'Hôn nhân bền, gia đình ít sóng gió. Có thể hơi bảo thủ.',
    sucKhoe: 'Các vấn đề thường liên quan lão hóa; cần phòng ngừa sớm.',
    phapLy: 'Ít vướng mắc pháp lý; uy tín cộng đồng cao.',
    khuyenNghi: 'Duy trì sức khỏe, mở rộng kiến thức, cân nhắc đổi mới khi cần.',
  },

  'Diên Niên + Phục Vị': {
    general:
      'Diên Niên được trấn bởi Phục Vị: nội lực vững, ít biến động — phù hợp nghiên cứu, nghề ổn định và tu dưỡng.',
    taiChinh: 'Thu nhập ổn, phù hợp nghề công ăn lương hoặc nghề chuyên môn dài hạn.',
    honNhan: 'Gia đình yên ấm; ít biến cố lớn.',
    sucKhoe: 'Dễ mỏi do ít vận động; nên tập thể dục đều.',
    phapLy: 'Ít rắc rối, xử lý nội bộ hiệu quả.',
    khuyenNghi: 'Quan tâm dinh dưỡng, vận động, tiếp tục phát triển chuyên môn bền vững.',
  },

  'Diên Niên + Tuyệt Mệnh': {
    general: 'Diên Niên nền tảng đối diện Tuyệt Mệnh: cảnh báo biến động lớn làm sụp đổ nền tảng nếu không chuẩn bị.',
    taiChinh: 'Rủi ro tài chính lớn nếu có biến cố; cần quỹ dự phòng và bảo hiểm.',
    honNhan: 'Quan hệ có thể rạn nứt; nên xử lý khủng hoảng sớm.',
    sucKhoe: 'Stress kéo dài dẫn tới suy nhược; can thiệp y tế khi cần.',
    phapLy: 'Nguy cơ kiện tụng, tranh chấp lớn; chuẩn bị pháp lý.',
    khuyenNghi: 'Xây kế hoạch khủng hoảng, giảm rủi ro, tìm hỗ trợ chuyên môn.',
  },

  'Diên Niên + Ngũ Quỷ': {
    general:
      'Diên Niên gặp Ngũ Quỷ: nền tảng có biến động; kết quả phụ thuộc mức độ Ngũ Quỷ mạnh hay yếu — có thể hóa hung thành cát nếu biết quản trị.',
    taiChinh: 'Thu nhập biến động; cần quan sát và điều chỉnh chiến lược.',
    honNhan: 'Quan hệ dễ dao động, cần giao tiếp rõ ràng.',
    sucKhoe: 'Mệt mỏi, mất ngủ nếu biến động kéo dài.',
    phapLy: 'Dễ dính thị phi; chứng từ và minh bạch rất quan trọng.',
    khuyenNghi: 'Theo dõi biến động, tránh quyết định lớn khi tình hình bất ổn.',
  },

  // ===== Phục Vị + ... =====
  'Phục Vị + Thiên Y': {
    general: 'Phục Vị trấn an Thiên Y: thích hợp phục hồi, tu dưỡng, nghề trị liệu; năng lượng bền và dễ chịu.',
    taiChinh: 'Tiền đủ dùng, ít biến động; phù hợp nghề tư vấn, chăm sóc.',
    honNhan: 'Quan hệ yên ả, dễ chịu; đôi khi hơi khép kín.',
    sucKhoe: 'Tốt nếu có chế độ nghỉ ngơi; rủi ro tiêu hóa do stress kéo dài.',
    phapLy: 'Ít va chạm pháp lý; hòa giải là lối xử ưu tiên.',
    khuyenNghi: 'Rèn thói quen tốt, tránh cô lập, tham gia nhóm cộng đồng để cân bằng.',
  },

  'Phục Vị + Sinh Khí': {
    general:
      'Phục Vị kềm Sinh Khí theo hướng tích cực: tăng tính bền vững cho năng lực phát triển; phù hợp nghề chuyên môn.',
    taiChinh: 'Thu nhập ổn định từ chuyên môn; không phù hợp đầu tư lướt sóng.',
    honNhan: 'Gia đình tôn trọng nghề nghiệp, hỗ trợ nhau.',
    sucKhoe: 'Chú ý cân bằng làm việc và nghỉ ngơi để tránh mất ngủ.',
    phapLy: 'Ít rắc rối pháp lý nếu tuân thủ nguyên tắc.',
    khuyenNghi: 'Lên kế hoạch nghề nghiệp dài hạn, rèn kỹ năng lãnh đạo bản thân.',
  },

  'Phục Vị + Diên Niên': {
    general: 'Phục Vị củng cố Diên Niên: nội lực vững, phù hợp học hành, nghiên cứu và nghề ổn định lâu dài.',
    taiChinh: 'Thu nhập ổn; thích hợp công việc hành chính, nghiên cứu.',
    honNhan: 'Gia đình yên ấm; ít biến cố.',
    sucKhoe: 'Cần chú ý cột sống, vận động hàng ngày.',
    phapLy: 'Ít rắc rối, giải quyết vấn đề bằng thỏa thuận.',
    khuyenNghi: 'Tập thể dục đều, nâng cao chuyên môn từ từ.',
  },

  'Phục Vị + Phục Vị': {
    general:
      'Phục Vị nhân đôi: cực kỳ tĩnh lặng, thích hợp tu dưỡng, thiền và công việc học thuật. Cuộc sống ít biến động.',
    taiChinh: 'Thu nhập đủ dùng, không bùng nổ. Phù hợp nghề ổn định.',
    honNhan: 'Yên ả nhưng dễ cô lập, cần mở rộng giao tiếp.',
    sucKhoe: 'Dễ mệt do ít vận động; chăm sóc dinh dưỡng.',
    phapLy: 'Rủi ro pháp lý thấp; ưu tiên phương thức giải quyết hòa bình.',
    khuyenNghi: 'Tham gia cộng đồng, rèn vận động, tránh sống khép kín.',
  },

  'Phục Vị + Tuyệt Mệnh': {
    general: 'Phục Vị gặp Tuyệt Mệnh: tĩnh bị đe dọa, cảnh báo tạm dừng quyết định lớn và củng cố nội lực.',
    taiChinh: 'Không nên vay mượn hoặc đầu tư mạo hiểm. Ưu tiên bảo toàn vốn.',
    honNhan: 'Im lặng kéo dài gây tổn thương; cần giao tiếp trị liệu khi cần.',
    sucKhoe: 'Rối loạn tiêu hóa, thần kinh nếu kéo dài; khám chuyên khoa khi có dấu hiệu.',
    phapLy: 'Rủi ro thủ tục dẫn tới phạt; cẩn thận khi ký kết.',
    khuyenNghi: 'Đóng băng kế hoạch lớn, phục hồi tinh thần và xử lý từng bước an toàn.',
  },

  'Phục Vị + Ngũ Quỷ': {
    general:
      'Phục Vị bị xáo trộn bởi Ngũ Quỷ: dễ hao tổn tinh thần, dễ bị lợi dụng; nên giữ công việc ổn định thay vì mở rộng.',
    taiChinh: 'Không nên cho vay, tránh hợp tác mập mờ; giữ quỹ dự phòng.',
    honNhan: 'Im lặng kéo dài dễ gây tổn thương; chủ động giao tiếp để hòa giải.',
    sucKhoe: 'Mất ngủ, co thắt dạ dày, cần khám tiêu hóa/ tâm lý nếu kéo dài.',
    phapLy: 'Rắc rối giấy tờ nhỏ; cẩn trọng khi giao dịch.',
    khuyenNghi: 'Dọn sạch yếu tố độc hại xung quanh, tìm trị liệu tâm lý nếu cần.',
  },

  'Phục Vị + Lục Sát': {
    general: 'Phục Vị trấn nhưng có sát khí: cần chuẩn bị pháp lý/an ninh khi hoạt động trong môi trường cạnh tranh.',
    taiChinh: 'Phù hợp nghề độc lập; tránh hợp tác mạo hiểm với đối tác không rõ.',
    honNhan: 'Áp lực bên ngoài có thể ảnh hưởng tình cảm; cần chia sẻ và xoa dịu nhau.',
    sucKhoe: 'Dễ đau cổ vai gáy, chấn thương nhẹ; vật lý trị liệu hữu ích.',
    phapLy: 'Nguy cơ khiếu kiện nhỏ; giữ chứng từ rõ ràng.',
    khuyenNghi: 'Chuẩn hóa hợp đồng, mua bảo hiểm tai nạn, giảm rủi ro vật lý.',
  },

  'Phục Vị + Họa Hại': {
    general: 'Phục Vị + Họa Hại: tĩnh bị quấy rối — phiền toái nhỏ nhưng kéo dài, cần kỷ luật để giữ hiệu suất.',
    taiChinh: 'Thu nhập ổn nhưng dễ gặp chi phí phát sinh do thị phi; nên quản trị rủi ro truyền thông.',
    honNhan: 'Hiểu lầm nhỏ dễ qua nếu biết xin lỗi; tránh nói nặng lời.',
    sucKhoe: 'Mệt mỏi, viêm mũi dị ứng; quản lý giấc ngủ và miễn dịch.',
    phapLy: 'Thị phi hơn kiện tụng nhưng vẫn cần lưu trữ chứng từ.',
    khuyenNghi: 'Thực hiện SOP, nghỉ giải lao, xử lý truyền thông kịp thời.',
  },

  'Phục Vị + Ngũ Quỷ (lặp)': {
    general: 'Đã nêu ở trên (Phục Vị + Ngũ Quỷ), tránh lặp lại chi tiết.',
  },

  // ===== Ngũ Quỷ + ... =====
  'Ngũ Quỷ + Thiên Y': {
    general:
      'Ngũ Quỷ mang tính xáo trộn, Thiên Y kềm chế phần nào — năng lực sáng tạo có thể mang đến tài lộc nhưng cần giữ tinh thần bình tĩnh.',
    taiChinh: 'Thu nhập có thể đến từ ý tưởng, sáng tạo; rủi ro do hành động bốc đồng.',
    honNhan: 'Cãi vã có nhưng dễ hàn gắn; trung thực là chìa khóa.',
    sucKhoe: 'Dễ mất ngủ, stress; trị liệu tinh thần hữu ích.',
    phapLy: 'Dễ vướng thị phi; minh bạch giúp giảm rủi ro.',
    khuyenNghi: 'Khai thác năng lực sáng tạo nhưng kỷ luật bản thân, dự phòng rủi ro tài chính.',
  },

  'Ngũ Quỷ + Sinh Khí': {
    general:
      'Ngũ Quỷ + Sinh Khí: tư duy linh hoạt, nhiều ý tưởng; nếu kèm kỷ luật có thể dùng sáng kiến để tạo thu nhập.',
    taiChinh: 'Ý tưởng mang tiền nhưng cần kiểm chứng và quản lý. Tránh đa cấp, cho vay lãi cao.',
    honNhan: 'Tư tưởng biến động, cần giữ lời hứa để duy trì niềm tin.',
    sucKhoe: 'Tinh thần thay đổi; quản lý stress giúp cải thiện hiệu quả.',
    phapLy: 'Cần lưu chứng từ, thỏa thuận rõ ràng khi hợp tác.',
    khuyenNghi: 'Thử nghiệm nhỏ, có lộ trình rõ ràng, tránh mở rộng quá sớm.',
  },

  'Ngũ Quỷ + Diên Niên': {
    general: 'Ngũ Quỷ tài hoa kết hợp Diên Niên vững: tiềm năng lãnh đạo sáng tạo cao nếu biết điều tiết cảm xúc.',
    taiChinh: 'Khả năng tạo thương hiệu cá nhân, thăng tiến; rủi ro do đào hoa gây xao nhãng.',
    honNhan: 'Quan hệ xã hội rộng; giữ ranh giới để tránh thị phi tình cảm.',
    sucKhoe: 'Cần giữ nhịp nghỉ ngơi, tránh lao lực.',
    phapLy: 'Giữ hình ảnh chuyên nghiệp để tránh rắc rối truyền thông.',
    khuyenNghi: 'Phát triển năng lực lãnh đạo kết hợp kiểm soát đời sống cá nhân.',
  },

  'Ngũ Quỷ + Phục Vị': {
    general: 'Ngũ Quỷ được Phục Vị trấn: sáng tạo có khuôn khổ, bền hơn và dễ chuyển thành nghề ổn định.',
    taiChinh: 'Thu nhập ổn từ nghề sáng tạo; ít rủi ro hơn khi có quy trình.',
    honNhan: 'Quan hệ có thử thách nhưng bền nếu có kỷ luật.',
    sucKhoe: 'Ổn hơn khi có Phục Vị; vẫn cần chăm sóc tinh thần.',
    phapLy: 'Ít rắc rối, nên bảo vệ tài sản trí tuệ.',
    khuyenNghi: 'Tổ chức ý tưởng, bản địa hóa quy trình, rèn kỷ luật.',
  },

  'Ngũ Quỷ + Tuyệt Mệnh': {
    general: 'Cặp cực xấu: dễ gây hành động liều, hậu quả nặng cả về sức khỏe và tài chính. Cần cẩn trọng tối đa.',
    taiChinh: 'Rủi ro phá sản, mất mát lớn nếu không thận trọng. Tránh mọi giao dịch lớn.',
    honNhan: 'Tan vỡ, xung đột nghiêm trọng; yêu cầu can thiệp chuyên môn.',
    sucKhoe: 'Nguy cơ bệnh nặng; theo dõi và can thiệp sớm là bắt buộc.',
    phapLy: 'Nguy cơ bị truy cứu trách nhiệm; tìm luật sư khi cần.',
    khuyenNghi: 'Ngắt rủi ro, ưu tiên bảo toàn mạng sống, tìm trợ giúp pháp lý và y tế.',
  },

  'Ngũ Quỷ + Lục Sát': {
    general: 'Ngũ Quỷ + Lục Sát: môi trường dễ bất ổn, đối đầu mạnh, đào hoa phức tạp; cảnh giác tiểu nhân.',
    taiChinh: 'Rất rủi ro khi hợp tác; dễ mất tiền do đối thủ/tiểu nhân.',
    honNhan: 'Đào hoa phức tạp, tình tay ba có thể xảy ra; giữ ranh giới rõ ràng.',
    sucKhoe: 'Tinh thần bất an; tìm trợ giúp tâm lý nếu cần.',
    phapLy: 'Nguy cơ tố tụng khi có xô xát; lưu chứng cứ và giấy tờ.',
    khuyenNghi: 'Giảm tiếp xúc xung đột, xem xét thay đổi môi trường nếu liên tục bị tổn hại.',
  },

  'Ngũ Quỷ + Họa Hại': {
    general: 'Ngũ Quỷ + Họa Hại: năng lượng làm tăng khả năng thị phi bằng lời nói, dễ dẫn đến rắc rối truyền thông.',
    taiChinh: 'Mất khách hoặc uy tín do phát ngôn; quản trị PR rất quan trọng.',
    honNhan: 'Lời nói gây tổn thương, dễ phải sửa sai lâu dài.',
    sucKhoe: 'Stress kéo dài, giảm đề kháng; nghỉ dưỡng cần thiết.',
    phapLy: 'Nguy cơ phỉ báng; cần PR/ pháp lý khi sự việc lan rộng.',
    khuyenNghi: 'Giữ im lặng khi cần, xử lý sự cố truyền thông khẩn trương.',
  },

  // ===== Lục Sát + ... =====
  'Lục Sát + Thiên Y': {
    general:
      'Lục Sát + Thiên Y: năng lượng sát kèm chữa lành — tiền bạc đến qua nghề dịch vụ, nhưng phải tỉ mỉ và chịu khó.',
    taiChinh: 'Thu nhập từ phục vụ, giao tế; yêu cầu chăm chút chi tiết. Rủi ro: mất tiền do sai sót nhỏ.',
    honNhan: 'Quan hệ có thể bị ảnh hưởng bởi chuyện bên ngoài; giữ thái độ tế nhị.',
    sucKhoe: 'Dễ mệt cơ-xương do lao động; chú ý an toàn khi làm việc.',
    phapLy: 'Ít rắc rối nếu tuân thủ luật pháp; chuẩn hóa giấy tờ kinh doanh.',
    khuyenNghi: 'Đào tạo kỹ năng phục vụ, quản lý chất lượng, bảo hộ lao động.',
  },

  'Lục Sát + Sinh Khí': {
    general: 'Lục Sát + Sinh Khí: hỗ trợ nhân duyên, kỹ năng giao tiếp tốt — dễ thu hút đối tác và khách hàng.',
    taiChinh: 'Thu nhập đến từ quan hệ; kỹ năng bán hàng và đối ngoại quyết định thành bại.',
    honNhan: 'Duyên tình thuận lợi, nhưng cần trung thực để bền lâu.',
    sucKhoe: 'Ổn nếu giữ nhịp làm việc hợp lý; chú ý ăn uống khi giao tiếp nhiều.',
    phapLy: 'Quan hệ xã hội có thể hỗ trợ khi cần pháp lý.',
    khuyenNghi: 'Rèn kỹ năng giao tiếp, giữ giới hạn nghề nghiệp rõ ràng.',
  },

  'Lục Sát + Diên Niên': {
    general:
      'Lục Sát + Diên Niên: phù hợp công việc hành chính, dịch vụ — xử lý quan hệ tốt sẽ mang lại lợi ích ổn định.',
    taiChinh: 'Thu nhập phụ thuộc quan hệ; giữ mối quan hệ tốt với đồng nghiệp và đối tác nữ có thể có lợi.',
    honNhan: 'Quan hệ gia đình/đối tác nữ có ảnh hưởng lớn; trân trọng họ sẽ giúp ổn định.',
    sucKhoe: 'Ổn nhưng dễ mệt do tương tác xã hội; giữ cân bằng.',
    phapLy: 'Chuẩn hóa thủ tục, tránh hợp tác mập mờ.',
    khuyenNghi: 'Xây dựng mối quan hệ bền vững, xử lý xung đột sớm.',
  },

  'Lục Sát + Phục Vị': {
    general: 'Lục Sát được Phục Vị trấn: sát khí có kiểm soát, năng lực bền hơn — phù hợp nghề độc lập kỷ luật.',
    taiChinh: 'Thu nhập ổn từ nghề cá nhân; cần chú trọng pháp lý khi hợp tác.',
    honNhan: 'Quan hệ có thử thách nhưng có thể ổn nếu chăm sóc cảm xúc.',
    sucKhoe: 'Dễ chấn thương nhẹ; chú ý an toàn khi thao tác.',
    phapLy: 'Rủi ro giấy tờ nhỏ; chuẩn hóa hợp đồng.',
    khuyenNghi: 'Chuẩn hóa quy trình, bảo hiểm tai nạn, đào tạo kỹ năng an toàn.',
  },

  'Lục Sát + Tuyệt Mệnh': {
    general: 'Lục Sát + Tuyệt Mệnh: tổ hợp cảnh báo cao về xung đột, tai nạn và tổn thất nặng nếu hành xử liều lĩnh.',
    taiChinh: 'Nguy cơ phá tài nếu đối đầu; tránh vay mượn lớn hoặc hợp tác rủi ro.',
    honNhan: 'Quan hệ có thể đổ vỡ, xảy ra xung đột nghiêm trọng.',
    sucKhoe: 'Nguy cơ tai nạn, thương tích; an toàn cá nhân cần ưu tiên.',
    phapLy: 'Khả năng bị tố tụng/ truy cứu; tìm pháp lý khi cần.',
    khuyenNghi: 'Rút lui khi gặp áp lực, hạn chế đối đầu trực diện, nâng cao an ninh cá nhân.',
  },

  'Lục Sát + Họa Hại': {
    general: 'Lục Sát + Họa Hại: ma sát kèm thị phi — dễ làm giảm uy tín và sinh rắc rối dai dẳng.',
    taiChinh: 'Mất mát do khiếu nại, hoàn trả; quản lý chất lượng và chứng từ cần nghiêm túc.',
    honNhan: 'Tin đồn ghen tuông có thể phá hoại quan hệ; xử lý khéo léo là chìa khóa.',
    sucKhoe: 'Stress ảnh hưởng tiêu hóa và da; khám khi cần.',
    phapLy: 'Nguy cơ kiện tụng dịch vụ; chuẩn bị hồ sơ và pháp lý.',
    khuyenNghi: 'Tăng kiểm soát chất lượng, xử lý khách hàng chuyên nghiệp.',
  },

  'Lục Sát + Ngũ Quỷ': {
    general:
      'Lục Sát + Ngũ Quỷ: xung + xáo — môi trường độc hại, nhiều đối đầu và đào hoa phức tạp; cảnh giác tiểu nhân.',
    taiChinh: 'Rất rủi ro khi hợp tác; dễ thất thoát do phá hoại hoặc tiểu nhân.',
    honNhan: 'Hôn nhân dễ bị xáo trộn, có duyên ngoài, đào hoa phức tạp.',
    sucKhoe: 'Tinh thần bất an, dễ trầm cảm; cần hỗ trợ tâm lý nếu cần.',
    phapLy: 'Nguy cơ tố tụng/ hình sự khi có xô xát; bảo vệ chứng cứ và pháp lý.',
    khuyenNghi: 'Tránh đối đầu, thay đổi môi trường nếu cần, tăng an ninh pháp lý.',
  },

  // ===== Họa Hại + ... =====
  'Họa Hại + Thiên Y': {
    general:
      'Họa Hại (khẩu tài) kết hợp Thiên Y: kiếm tiền bằng lời nói, dịch vụ giao tiếp; nhưng dễ vướng thị phi nếu phát ngôn không khéo.',
    taiChinh: 'Thu nhập từ bán hàng, PR, diễn thuyết; rủi ro do phát ngôn gây ảnh hưởng doanh thu.',
    honNhan: 'Lời nói có sức nặng, có thể gây tổn thương nếu thiếu tế nhị.',
    sucKhoe: 'Chú ý họng, miệng, gan-thận theo thói quen ăn uống; duy trì giọng và sức khỏe họng.',
    phapLy: 'Dễ bị truyền thông chỉ trích; xử lý truyền thông kịp thời sẽ giảm tổn thất.',
    khuyenNghi: 'Rèn kỹ năng giao tiếp, kiểm soát phát ngôn, đầu tư PR/ pháp lý khi cần.',
  },

  'Họa Hại + Sinh Khí': {
    general:
      'Họa Hại + Sinh Khí: khẩu tài mạnh, dễ gây chú ý, phù hợp nghề marketing, sales; nhưng cần kiểm soát thái độ để giữ khách.',
    taiChinh: 'Lời nói giúp bán hàng, ký hợp đồng; rủi ro do tâm lý khoa trương.',
    honNhan: 'Gây ấn tượng tốt nếu biết khiêm nhường; tránh khoe khoang quá mức.',
    sucKhoe: 'Ổn nhưng dễ mệt do hoạt ngôn nhiều; giữ giọng và chăm sóc họng.',
    phapLy: 'Không nên dùng chiêu trò PR mơ hồ; minh bạch trách nhiệm.',
    khuyenNghi: 'Dùng khẩu tài xây dựng thương hiệu, học kỹ năng thuyết phục văn minh.',
  },

  'Họa Hại + Diên Niên': {
    general:
      'Họa Hại + Diên Niên: năng lực khẩu tài đi kèm tổ chức tốt — phù hợp ngành truyền thông, giáo dục, luật sư tranh tụng.',
    taiChinh: 'Thu nhập từ hoạt động truyền thông/giảng dạy; rủi ro khi tranh luận thiếu căn cứ.',
    honNhan: 'Khả năng tranh luận trong gia đình; rèn kỹ năng lắng nghe giúp giảm xung đột.',
    sucKhoe: 'Chú ý giọng nói, họng, và stress do cường độ giao tiếp.',
    phapLy: 'Nguy cơ vướng tranh luận pháp lý; chuẩn bị luận cứ, chứng cứ.',
    khuyenNghi: 'Trau dồi kiến thức chuyên môn, giữ văn phong ôn hòa khi tranh luận.',
  },

  'Họa Hại + Phục Vị': {
    general: 'Họa Hại được Phục Vị hỗ trợ: khẩu tài bền, phù hợp nghề giảng dạy, đào tạo; dễ ổn định lâu dài.',
    taiChinh: 'Thu nhập ổn từ nghề dạy/huấn luyện; ít rủi ro nếu có đạo đức nghề nghiệp.',
    honNhan: 'Giao tiếp gia đình tốt nếu biết kiềm chế; tránh phát ngôn tổn thương.',
    sucKhoe: 'Ổn nhưng cần chăm giọng và sức khỏe họng, mũi.',
    phapLy: 'Ít rắc rối pháp lý nếu kiểm soát phát ngôn.',
    khuyenNghi: 'Xây dựng nghề bằng uy tín, tránh dùng chiêu trò gây phản cảm.',
  },

  'Họa Hại + Tuyệt Mệnh': {
    general:
      'Họa Hại + Tuyệt Mệnh: cảnh báo cao cho phát ngôn gây tổn hại lớn — có thể dẫn đến tai nạn nghiêm trọng về mặt xã hội hoặc pháp lý.',
    taiChinh: 'Có thể kiếm nhanh nhưng tiêu nhanh; rủi ro danh tiếng lớn gây mất thu nhập lâu dài.',
    honNhan: 'Lời nói có thể phá hoại niềm tin; sửa chữa cần thời gian dài.',
    sucKhoe: 'Có tín niệm liên quan gan-thận; thực tế cần giữ lối sống lành mạnh để giảm rủi ro.',
    phapLy: 'Nguy cơ kiện tụng hoặc xử phạt; cần PR và pháp lý xử lý khẩn.',
    khuyenNghi: 'Hạn chế phát ngôn gây sốc, thận trọng truyền thông, xin lỗi kịp thời khi sai.',
  },

  'Họa Hại + Lục Sát': {
    general:
      'Họa Hại + Lục Sát: lời nói làm tổn thương, khiến người khác im lặng hoặc phản ứng mạnh — dễ gây mất khách và uy tín.',
    taiChinh: 'Mất đơn hàng, khách hàng do phát ngôn không khéo; quản trị quan hệ khách hàng cần tốt.',
    honNhan: 'Lời nói vô ý làm tổn thương người thân; cần rèn kỹ năng biểu đạt.',
    sucKhoe: 'Stress do xung đột, dễ ảnh hưởng tiêu hóa và thần kinh.',
    phapLy: 'Nguy cơ tranh chấp do phát ngôn; thận trọng khi công bố thông tin.',
    khuyenNghi: 'Học lắng nghe, thực hành giao tiếp không gây hại, xin lỗi và sửa chữa khi cần.',
  },

  'Họa Hại + Ngũ Quỷ': {
    general:
      'Họa Hại + Ngũ Quỷ: lời nói kỳ dị kết hợp tư tưởng biến hóa — có thể gây tranh luận lặp đi lặp lại và khiến người khác mệt mỏi.',
    taiChinh:
      'Có thể hấp dẫn một nhóm khách lạ nhưng mất phần lớn thị trường chính; cần chọn chiến lược tiếp cận đúng khách hàng.',
    honNhan: 'Dễ tạo xung đột cảm xúc; giữ bình tĩnh là chìa khóa.',
    sucKhoe: 'Tinh thần hao tổn; nghỉ ngơi và trị liệu tâm lý nếu cần.',
    phapLy: 'Rủi ro truyền thông tiêu cực; xử lý nhẹ nhàng, không đối đầu ầm ĩ.',
    khuyenNghi: 'Định vị rõ đối tượng, tránh tranh luận không cần thiết, đầu tư vào PR và chăm sóc khách hàng.',
  },
  'Tuyệt Mệnh + Tuyệt Mệnh': {
    general: 'Đây là sự kết hợp nặng về xung khắc, mang tính triệt tiêu, thường tạo cảm giác bế tắc.',
    taiChinh: 'Dễ gặp thất bại tài chính, đầu tư rủi ro. Tuy nhiên cũng có thể giúp cắt bỏ cái cũ để xây mới.',
    honNhan: 'Hôn nhân dễ chia ly, mâu thuẫn sâu sắc. Mặt tích cực là có cơ hội học cách buông bỏ.',
    sucKhoe: 'Ảnh hưởng xấu đến sức khỏe, dễ suy nhược, bệnh vặt kéo dài.',
    phapLy: 'Dễ vướng tranh chấp pháp lý, kiện tụng. Nhưng cũng giúp lộ rõ vấn đề ẩn giấu.',
    khuyenNghi:
      "Nên tránh dùng sim mang tổ hợp này. Nếu buộc phải dùng thì coi như 'cảnh báo' để luôn cẩn trọng, không ỷ lại.",
  },

  'Tuyệt Mệnh + Ngũ Quỷ': {
    general: 'Hai cung xấu gặp nhau tạo năng lượng hỗn loạn, dễ biến động bất ngờ.',
    taiChinh: 'Tài chính thất thường, tiền vào nhanh nhưng ra cũng nhanh, khó giữ.',
    honNhan: 'Quan hệ nhiều sóng gió, dễ có kẻ thứ ba xen vào.',
    sucKhoe: 'Ảnh hưởng thần kinh, mất ngủ, lo âu. Nhưng cũng giúp con người học cách chịu đựng.',
    phapLy: 'Có nguy cơ dính vào thị phi, kiện tụng. Cần đề phòng giấy tờ, hợp đồng.',
    khuyenNghi: 'Nên kiêng. Nếu buộc dùng thì chú trọng kiểm soát cảm xúc, ghi nhớ mọi cam kết bằng văn bản.',
  },

  'Tuyệt Mệnh + Lục Sát': {
    general: "Tổ hợp này mang tính 'tiêu hao năng lượng', vừa dễ gây xung đột vừa làm mất cân bằng.",
    taiChinh: 'Dễ gặp thất bát, hao hụt vốn. Nhưng đôi khi giúp thoát khỏi sự lệ thuộc tài chính.',
    honNhan: 'Gia đạo không yên, dễ xảy ra xung đột cha mẹ – con cái.',
    sucKhoe: 'Dễ mắc bệnh mãn tính, sức đề kháng kém.',
    phapLy: 'Có nguy cơ liên quan tới tranh chấp đất đai, tài sản.',
    khuyenNghi: "Không khuyến khích. Nếu đã sở hữu, hãy xem nó như 'lời nhắc' để sống kỷ luật, tránh tham lam.",
  },

  'Tuyệt Mệnh + Họa Hại': {
    general: 'Hai cung xấu tạo cảm giác trì trệ, nhiều trắc trở, nhưng cũng có giá trị cảnh báo mạnh mẽ.',
    taiChinh: 'Thường gặp khó khăn tài chính, đầu tư thất bại. Nhưng cũng giúp tránh sa đà vào nợ nần lớn.',
    honNhan: 'Hôn nhân dễ khủng hoảng, có khoảng cách trong tình cảm.',
    sucKhoe: 'Sức khỏe yếu, hay mắc bệnh đường tiêu hóa hoặc thần kinh.',
    phapLy: 'Thường bị người khác chơi xấu, lừa gạt.',
    khuyenNghi: "Nếu số sim mang tổ hợp này thì chỉ nên coi như 'lá bùa nhắc nhở' để luôn cảnh giác, không mong cầu.",
  },

  'Tuyệt Mệnh + Thiên Y': {
    general: 'Xung – hợp giao thoa. Tuyệt Mệnh gây hao tổn nhưng Thiên Y giúp cứu vãn, cân bằng phần nào.',
    taiChinh: 'Tiền bạc dễ thất thoát, nhưng lại có quý nhân giúp đỡ đúng lúc.',
    honNhan: 'Gia đạo dễ mâu thuẫn nhưng có cơ hội hàn gắn nhờ sự kiên nhẫn.',
    sucKhoe: 'Dễ bệnh nhưng được chữa trị kịp thời, tránh hậu quả lớn.',
    phapLy: 'Có thể gặp kiện tụng nhưng có người can thiệp, hỗ trợ.',
    khuyenNghi: 'Nếu có sim dạng này, hãy tập trung phát triển tâm linh, sống thiện để tăng sức cứu của Thiên Y.',
  },

  'Tuyệt Mệnh + Sinh Khí': {
    general: 'Sinh Khí mang năng lượng mạnh mẽ, có thể hóa giải phần tiêu cực của Tuyệt Mệnh.',
    taiChinh: 'Thử thách lớn nhưng vẫn có cơ hội thành công nhờ nỗ lực bền bỉ.',
    honNhan: 'Dễ xảy ra chia ly, nhưng nếu cả hai cùng cố gắng thì tình cảm bền vững hơn.',
    sucKhoe: 'Sức khỏe thất thường, dễ ốm nhưng hồi phục nhanh.',
    phapLy: 'Có nguy cơ kiện tụng, nhưng cũng là cơ hội để chứng minh bản thân.',
    khuyenNghi: 'Nếu dùng sim này, phải kiên trì, không nóng vội. Lấy khó khăn làm động lực.',
  },

  'Tuyệt Mệnh + Diên Niên': {
    general: 'Diên Niên giữ ổn định, giúp giảm bớt sự bế tắc của Tuyệt Mệnh.',
    taiChinh: 'Tài chính khó khăn nhưng có sự trợ giúp từ người thân.',
    honNhan: 'Tình cảm dễ bị thử thách, nhưng nhờ sự kiên nhẫn nên duy trì được.',
    sucKhoe: 'Cơ thể dễ mệt mỏi nhưng tinh thần vẫn ổn.',
    phapLy: 'Có thể bị vu oan, nhưng cuối cùng sự thật được sáng tỏ.',
    khuyenNghi: 'Dùng sim dạng này nên chú trọng đến gia đình, coi gia đạo là gốc rễ để vượt qua biến cố.',
  },

  'Tuyệt Mệnh + Phục Vị': {
    general: 'Một bên gây tiêu cực, một bên tạo sự hồi phục. Đây là tổ hợp vừa nguy vừa an.',
    taiChinh: 'Tài chính dễ trắc trở nhưng có cơ hội làm lại từ đầu.',
    honNhan: 'Dễ xảy ra khủng hoảng tình cảm, nhưng nếu cùng nhau nhìn lại thì có thể gắn kết hơn.',
    sucKhoe: 'Có bệnh nhưng được chữa khỏi hoặc tìm thấy nguyên nhân.',
    phapLy: 'Khó tránh kiện cáo, nhưng có thể kết thúc trong hòa giải.',
    khuyenNghi: 'Người dùng sim này cần học cách dừng lại, nghỉ ngơi để tái tạo năng lượng, tránh cố chấp.',
  },

  // ===== Tổng kết - khuyến nghị chung về số 0 =====
  'Ghi chú - Sim chứa số 0': {
    general:
      'Theo quan điểm bạn cung cấp, sim có nhiều số 0 mang trường năng lượng yếu (ý bạn là: từ đại già không), có thể ảnh hưởng xấu tới các mặt cuộc sống. Trường hợp này cần cân nhắc thay sim hoặc phân bổ sim phụ để cân bằng.',
    taiChinh:
      "Số 0 có thể biểu thị tình trạng cạn kiệt tài lực; nếu sim 'dính 0' nhiều, không khuyến nghị dùng làm số chính cho công việc, giao dịch quan trọng.",
    honNhan:
      'Số 0 nhiều có thể liên quan cảm xúc trống rỗng, lạnh nhạt; duy trì giao tiếp tích cực trong gia đình để khắc phục.',
    sucKhoe: 'Trường năng lượng yếu dễ kéo theo tâm lý tiêu cực; chăm sóc sức khỏe tinh thần và thể chất là bắt buộc.',
    phapLy: 'Từ trường xấu dễ kéo theo thị phi; nên thận trọng khi công khai thông tin cá nhân.',
    khuyenNghi:
      'Nếu sim có nhiều 0, tốt nhất dùng sim phụ, hoặc thay sim khác; kết hợp phong thủy, thay đổi hành vi để bù trừ.',
  },
};

// =============================
// DỮ LIỆU CUỐI CÙNG (đã có nl1, nl2)
// =============================
export const BOSOKETHOP = enrichEnergyCombinations(ENERGY_COMBINATIONS);

export const FIVE_DIGIT_MAP = {
  80004: 'Tuyệt Mệnh',
};

export const NANG_LUONG = {
  'Sinh Khí': {
    nguHanh: 'Mộc',
    lug: 'moc',
    general:
      'Phục Vị là năng lượng của sự bình an và tập trung. Phục Vị giúp người dùng cảm thấy an yên, có sức mạnh tinh thần vững vàng, dễ dàng vượt qua khó khăn. Năng lượng này phù hợp với những ai cần sự ổn định, tập trung, giúp củng cố niềm tin vào bản thân.',
    taiChinh:
      'Rất tốt cho các lĩnh vực: kinh doanh thương mại, tài chính – ngân hàng, bất động sản, đầu tư dài hạn, công nghệ. Hạn chế tham gia: chứng khoán ngắn hạn, cờ bạc, ngành nghề mang tính rủi ro cao.',
    honNhan:
      'Đời sống hôn nhân nhìn chung hạnh phúc, dễ gặp bạn đời hỗ trợ. Tuy nhiên đôi lúc có xu hướng đặt nặng sự nghiệp hơn gia đình, cần cân bằng.',
    sucKhoe:
      'Thường có nền tảng sức khỏe tốt. Dễ gặp triệu chứng: mệt mỏi do làm việc quá sức, stress. Cơ quan liên quan: gan, dạ dày, hệ tuần hoàn. Khám gợi ý: kiểm tra men gan, nội soi dạ dày – tá tràng, đo huyết áp, xét nghiệm máu tổng quát.',
    phapLy: 'Ít vướng kiện tụng, nếu có cũng thường được giải quyết theo hướng có lợi. Có quý nhân phù trợ.',
    khuyenNghi:
      'Nên đầu tư vào các dự án lâu dài, xây dựng uy tín, giữ cân bằng công việc – gia đình. Tránh tham công tiếc việc, cần tập thể thao điều độ để duy trì phong độ.',
  },

  'Thiên Y': {
    nguHanh: 'Thổ',
    lug: 'tho',
    general:
      'Năng lượng Thiên Y tập trung vào sức khỏe và sự bình an. Thiên Y có khả năng cải thiện tình trạng sức khỏe, giúp cơ thể khỏe mạnh, tinh thần sảng khoái, đồng thời bảo vệ khỏi những tai họa bất ngờ, mang lại cuộc sống an lành và thư thái.',
    taiChinh:
      'Tốt cho các lĩnh vực: y tế, dược phẩm, chăm sóc sức khỏe, giáo dục, nghiên cứu, dịch vụ xã hội. Không phù hợp với ngành nghề nhiều rủi ro tài chính hoặc đầu tư mạo hiểm.',
    honNhan: 'Gia đình hòa thuận, tình cảm vợ chồng gắn bó, con cái hiếu thảo. Dễ gặp bạn đời biết quan tâm và hỗ trợ.',
    sucKhoe:
      'Thường ít bệnh nặng, nhưng có thể gặp: rối loạn tiêu hóa, mất ngủ, đau đầu nhẹ. Cơ quan liên quan: dạ dày, thần kinh, hệ miễn dịch. Khám gợi ý: nội soi dạ dày, kiểm tra thần kinh, khám miễn dịch.',
    phapLy: 'Có xu hướng tránh được tranh chấp. Nếu gặp rắc rối cũng được giải quyết êm đẹp.',
    khuyenNghi: 'Nên duy trì thói quen sinh hoạt lành mạnh, thường xuyên giúp đỡ người khác để tích thêm phúc đức.',
  },

  'Diên Niên': {
    nguHanh: 'Kim',
    lug: 'kim',
    general:
      'Đây là nguồn năng lượng mang đến sự ổn định và hòa thuận. Năng lượng Diên Niên giúp cải thiện các mối quan hệ gia đình, đối tác và đồng nghiệp. Năng lượng này thường phù hợp cho những người muốn có cuộc sống ổn định và mối quan hệ bền vững.',
    taiChinh:
      'Tốt cho: ngoại giao, luật pháp, hợp tác kinh doanh, quản trị, thương mại quốc tế. Không hợp với ngành nghề cần sự đột phá quá nhanh.',
    honNhan: 'Gia đình yên ấm, vợ chồng hòa hợp, ít mâu thuẫn lớn. Có hôn nhân bền vững.',
    sucKhoe:
      'Sức khỏe ổn, nhưng dễ gặp: cao huyết áp, mỡ máu, bệnh mãn tính về tim mạch. Cơ quan liên quan: tim, mạch máu, hệ tuần hoàn. Khám gợi ý: đo huyết áp, điện tâm đồ, siêu âm tim.',
    phapLy: 'Quan hệ xã hội tốt nên ít vướng vào kiện tụng. Nếu có thường được hòa giải.',
    khuyenNghi: 'Nên chú trọng giữ gìn sức khỏe lâu dài, cân bằng ăn uống và tập thể dục đều đặn.',
  },

  'Phục Vị': {
    nguHanh: 'Mộc',
    lug: 'moc',
    general:
      'Phục Vị là năng lượng của sự bình an và tập trung. Phục Vị giúp người dùng cảm thấy an yên, có sức mạnh tinh thần vững vàng, dễ dàng vượt qua khó khăn. Năng lượng này phù hợp với những ai cần sự ổn định, tập trung, giúp củng cố niềm tin vào bản thân.',
    taiChinh:
      'Hợp các lĩnh vực: nghiên cứu, giáo dục, tôn giáo, tâm lý, quản trị nhân sự. Không hợp với các ngành nghề quá áp lực hoặc cần cạnh tranh gay gắt.',
    honNhan: 'Tình cảm thường yên ổn, gia đình ít sóng gió. Tuy nhiên đôi khi thiếu sự lãng mạn, dễ rơi vào nhàm chán.',
    sucKhoe:
      'Có thể gặp: rối loạn lo âu, trầm cảm nhẹ, mất ngủ. Cơ quan liên quan: hệ thần kinh, não bộ. Khám gợi ý: khám tâm lý, xét nghiệm hormone, kiểm tra giấc ngủ.',
    phapLy: 'Ít xảy ra tranh chấp, thường giữ vai trò trung gian hòa giải.',
    khuyenNghi: 'Nên học cách đổi mới, sáng tạo để tránh bảo thủ. Thực hành thiền, yoga để cân bằng nội tâm.',
  },

  'Ngũ Quỷ': {
    nguHanh: 'Hỏa',
    lug: 'hoa',
    general:
      'Ngũ Quỷ là năng lượng xấu, biểu tượng cho khó khăn, mất mát và trở ngại. Ngũ Quỷ thường mang lại rủi ro, làm giảm may mắn trong công việc và dễ dẫn đến thất bại.',
    taiChinh:
      'Không thuận lợi cho các lĩnh vực kinh doanh tự do, đầu tư mạo hiểm, chứng khoán. Hợp hơn với nghề có tính ổn định như kỹ thuật, sản xuất, nghề nghiệp mang tính quy củ.',
    honNhan:
      'Dễ xảy ra mâu thuẫn trong hôn nhân, quan hệ tình cảm sóng gió. Cần sự kiên nhẫn và bao dung mới giữ được hạnh phúc.',
    sucKhoe:
      'Dễ gặp: đau dạ dày, bệnh về đường hô hấp, suy nhược cơ thể. Cơ quan liên quan: phổi, dạ dày, hệ thần kinh. Khám gợi ý: X-quang phổi, nội soi dạ dày, xét nghiệm máu.',
    phapLy: 'Có nguy cơ vướng kiện tụng, tranh chấp. Nên cẩn trọng trong hợp đồng và giấy tờ.',
    khuyenNghi: 'Hạn chế tham gia việc lớn khi vận chưa thông. Cần giữ bình tĩnh, kiềm chế nóng nảy để tránh xung đột.',
  },

  'Lục Sát': {
    nguHanh: 'Thủy',
    lug: 'thuy',
    general:
      'Năng lượng Lục Sát tượng trưng cho sự trắc trở và rối ren trong các mối quan hệ. Số có Lục Sát dễ làm người dùng gặp thị phi, tranh cãi, và các vấn đề về pháp lý. Loại năng lượng này nên được tránh khi lựa chọn số để tránh những xung đột không đáng có.',
    taiChinh:
      'Không thuận lợi cho hợp tác kinh doanh hoặc đầu tư chung. Hợp hơn với công việc độc lập, sáng tạo, nghiên cứu cá nhân. Tránh các ngành cần sự phối hợp tập thể cao.',
    honNhan: 'Dễ nảy sinh mâu thuẫn, bất đồng trong hôn nhân. Có nguy cơ ly thân, xa cách.',
    sucKhoe:
      'Có thể gặp: bệnh xương khớp, đau lưng, sỏi thận. Cơ quan liên quan: thận, xương sống, xương khớp. Khám gợi ý: siêu âm thận, chụp X-quang cột sống, khám chuyên khoa cơ xương khớp.',
    phapLy: 'Dễ liên quan đến tranh chấp tài sản, đất đai. Nên cẩn thận giấy tờ nhà cửa.',
    khuyenNghi:
      'Học cách kiểm soát cảm xúc, tránh tranh chấp vô ích. Tập trung vào công việc cá nhân để giảm xung đột.',
  },

  'Họa Hại': {
    nguHanh: 'Thổ',
    lug: 'tho',
    general:
      'Đây là nguồn năng lượng tiêu cực, mang đến sự bất hòa, gây xui xẻo trong công việc và cuộc sống. Họa Hại có thể ảnh hưởng xấu đến tinh thần, gây ra mâu thuẫn, sự cố, dẫn đến mất tài lộc. Do đó, cần tránh các con số hoặc dãy số có năng lượng này.',
    taiChinh:
      'Không nên đầu tư lớn. Hợp hơn với công việc ổn định, ít cạnh tranh. Tránh cho vay, đầu tư bất động sản hoặc tham gia các dự án mạo hiểm.',
    honNhan: 'Gia đạo thường có tranh cãi nhỏ, nhưng không quá nghiêm trọng. Cần sự nhẫn nhịn để duy trì hòa khí.',
    sucKhoe:
      'Dễ gặp: bệnh tiêu hóa, rối loạn chuyển hóa, gan nhiễm mỡ. Cơ quan liên quan: gan, hệ tiêu hóa. Khám gợi ý: siêu âm gan, xét nghiệm men gan, nội soi tiêu hóa.',
    phapLy: 'Có thể bị kẻ xấu vu oan, lừa gạt. Cần cẩn trọng trong ký kết hợp đồng.',
    khuyenNghi: 'Nên sống giản dị, tránh tham vọng quá mức. Cẩn thận trong quan hệ bạn bè và đối tác.',
  },

  'Tuyệt Mệnh': {
    nguHanh: 'Kim',
    lug: 'kim',
    general:
      'Đây là nguồn năng lượng gây ra bệnh tật, tai nạn hoặc đổ vỡ trong các mối quan hệ. Tuyệt Mệnh thường ảnh hưởng xấu đến sức khỏe, gây chia ly, thất bại và vận xui.',
    taiChinh:
      'Không thuận lợi cho kinh doanh, đầu tư. Chỉ nên làm nghề ổn định, có quy củ. Không nên tham gia chứng khoán, bất động sản hay lĩnh vực rủi ro.',
    honNhan: 'Hôn nhân dễ đổ vỡ, tình cảm trắc trở. Cần sự cảm thông lớn mới duy trì được.',
    sucKhoe:
      'Nguy cơ cao mắc bệnh nặng: ung thư, tim mạch, tai biến. Cơ quan liên quan: tim, não, hệ miễn dịch. Khám gợi ý: kiểm tra tim mạch định kỳ, MRI não, xét nghiệm ung thư tầm soát.',
    phapLy: 'Dễ gặp kiện tụng, tranh chấp lớn, thậm chí vướng vòng lao lý nếu không cẩn trọng.',
    khuyenNghi:
      'Cần sống hướng thiện, làm việc thiện để hóa giải. Nên thận trọng trong mọi quyết định lớn, đặc biệt về tài chính và quan hệ.',
  },
  'Số 0': {
    tongQuan:
      'Số 0 mang ý nghĩa Tứ đại giai không: tài không, vận không, sự nghiệp không, hôn nhân không, sức khỏe không. Đây là con số rỗng, không có năng lượng, tượng trưng cho hư vô. Trong sim phong thủy, số 0 bị coi là hung số, kéo giảm toàn bộ năng lượng của dãy số.',
    taiChinh:
      'Khó tụ tài, làm ra nhưng khó giữ, dễ hao tán, thất thoát. Không thuận lợi cho các lĩnh vực kinh doanh, đầu tư, tài chính. Dễ gặp cảnh vay nợ hoặc tiền bạc không ổn định.',
    honNhan:
      'Hôn nhân dễ lạnh nhạt, thiếu gắn kết. Người dùng số 0 nhiều thường có xu hướng cô đơn, tình cảm dễ phai nhạt, khó tìm được bạn đời phù hợp.',
    sucKhoe:
      'Dễ suy kiệt năng lượng, tinh thần trống rỗng. Triệu chứng thường gặp: mệt mỏi kéo dài, suy nhược cơ thể, mất ngủ, rối loạn thần kinh thực vật. Cơ quan liên quan: hệ thần kinh, tim mạch, hệ tiêu hóa. Khám gợi ý: khám chuyên khoa thần kinh, đo điện tim ECG, nội soi dạ dày – đại tràng, xét nghiệm chức năng gan.',
    phapLy:
      'Dễ gặp thị phi, vướng rắc rối giấy tờ, hợp đồng, tranh chấp không đâu. Khó có quý nhân trợ giúp khi rơi vào hoàn cảnh này.',
    khuyenNghi:
      'Nếu sim có nhiều số 0 thì nên thay đổi, hạn chế dùng. Nếu bắt buộc phải dùng, cần kết hợp với những con số cát lợi khác để giảm hung. Đồng thời, nên tu tâm dưỡng tính, bố thí tạo phúc, tập khí công hoặc thiền để bồi đắp năng lượng cho bản thân.',
  },
};

// -----------------------------
// 2) DETAILED MEANINGS (hiển thị nội dung chi tiết cho UI)
// -----------------------------
export const ENERGY_DETAILS = {
  'Thiên Y': {
    name: 'Thiên Y',
    nguHanh: 'Thổ',
    lug: 'tho',
    chomSao: 'Cự Môn',
    dacDiem:
      'Trời sinh tư chất tốt, thông minh, trong công tác dễ thành ông chủ, hoặc trợ thủ đắc lực cho ông chủ, mang đến tài phú cùng nghiệp tích, ở vào địa vị cao thượng, chính đào hoa, hay giúp người nguy khốn, thiên sinh đơn thuần, nhưng dễ rơi vào các tình huống không có chủ kiến hoặc vì thiên tính thiện lương. Từ trường số Thiên Y là tình cảm tài phú ai cũng thích, nhưng ảnh hướng trái chiều của nó là vấn đề huyết áp cũng cần đặc biệt chú ý, cho nên không phải từ trường năng lượng số Thiên Y nhiều là tốt, cần đặc biệt chú ý chọn sai số cũng có thể dẫn đến ly hôn hoặc vấn đề huyết áp. Từ trường năng lượng số Thiên Y chỉ cần là số điện thoại di động có xuất hiện từ trường số Thiên Y hoặc số thẻ căn cước đến vận thế, đều sẽ sinh ra hiện tượng tình cảm, tại thời điểm này, gặp đối tượng kết hôn là không khó, chỉ là xem người đó có nguyện ý hay không, rất nhiều người trong từ trường số Thiên Y  nhưng chưa chắc sẽ kết hôn, cái này còn phải xem từ trường năng lượng số Thiên Y quá nhỏ. Nếu đã kết hôn khi vận thế đang chạy trong từ trường năng lượng số Thiên Y, có thể là lúc cuộc sống hôn nhân tốt đẹp nhất, đầy hạnh phúc. Nếu trước đó không may mắn, thì hiện tại có thể yên tâm từ trường năng lượng số Thiên Y sẽ trợ giúp cho hài lòng, tình yêu hạnh phúc mỹ mãn, nên lợi dụng tốt đoạn thời gian may mắn này để làm một chút chuyện muốn làm, qua vận thế này, liền không chắc mọi thứ sẽ hài lòng. Năng lượng từ trường số Thiên Y không cần lo về tài vận, năng lượng từ trường số Thiên Y tiền kiếm được đều từ tám phương, phương hướng kiếm tiền chân chính nhất định phải từ số thẻ căn cước và nhớ đắc thủ số điện thoại cùng một chỗ để giải thích, có được từ trường số Thiên Y, ứng thiện dùng hết năng lượng thiên gia cho, lợi dụng thật tốt, chắc chắn vận thế sẽ mang đến càng nhiều vui sướng. Về phương diện sức khỏe tương đối dễ phát sinh vấn đề cao huyết lập và hệ thống tuần hoàn máu, đối với người hơi lớn tuổi, cần đặc biệt chú ý không phải từ trường số Thiên Y nhiều là tốt, vì năng lượng số Thiên Y cát hung đều phải quan hệ với năng lượng số phía trước và phía sau, là từ trường chính diện hoặc mặt trái, phụ trách từ trường năng lượng số Thiên Y cơ hồ đều là lấy chính diện năng lượng quan sát, năng lượng tử trường số Thiên Y mạnh hay yếu đều quan hệ đến vận thế tốt xấu, nhưng cơ bản đều là may mắn, chỉ là phần chia năng lượng cao thấp, và có thể kiếm được tiền nhiều hay ít, phải chăng phù hợp kết hôn không mà thôi.',
    uuDiem: 'Thông minh, thiện lương, lòng dạ khoáng đạt có thể thành đại sự, có thể mang đến tài vận, hôn nhân.',
    khuyetDiem:
      'Quá thiện lương, không so đo, bởi vậy dễ dàng bị lừa, bởi vì người Thiên Y không thiếu tiền, cho nên thường đối với tiền không có khái niệm, hoặc là ngẫu nhiên bỏ lỡ tiểu tài.',
    taiVan:
      'Tiền tài đại danh từ, chính tài, thiên tài, tiền của phi nghĩa bát phương tài đến, dùng tiền cũng tương đối hào phóng.',
    suNghiep:
      'Có thể thành sự, trở thành ông chủ hoặc cánh tay đắc lực của ông chủ, công trạng tốt, thích tông giáo mệnh lý, giác quan thứ sáu mạnh.',
    honNhan: 'Chính đào hoa đại danh từ, có hiện tượng kết hôn, dễ gặp đối tượng lý tưởng, tình cảm ân ái, ngọt ngào.',
    sucKhoe: 'Vấn đề về huyết áp, tuần hoàn máu, cùng bệnh tai mắt mũi.',
    khuyenNghi: 'Giữ lối sống lành mạnh, kiểm tra định kỳ.',
  },
  'Sinh Khí': {
    name: 'Sinh Khí',
    nguHanh: 'Mộc',
    lug: 'moc',
    chomSao: 'Tham Lang',
    dacDiem:
      'Tùy duyên, có quý nhân tương trợ, yên vui, tư tưởng hoạt bát, nhìn thoáng được, co giãn, luôn có người trợ giúp, có thể chuyển nguy thành an, đối với sự tình cũng không cưỡng cầu, bình chân như vại, trong sự nghiệp có người dẫn tiến hỗ trợ, không cần hao tổn nhiều tâm trí. Sinh Khí là một trong 4 cát tinh, Sinh Khí tuy tốt nhưng từ trường mặt trái cũng nhiều, chưa chắc đã thật tốt, cần xem vị trí của nó trong số điện thoại di động. Từ trường năng lượng số Sinh Khí xuất hiện khiến mọi việc đều thuận lợi, khắp nơi xuất hiện sinh cơ, trong mọi năng lượng số, từ trường số Sinh Khí là thứ làm cho con người sinh ra hi vọng nhất vì Sinh Khí kiểu gì cũng sẽ là khi nguy hiểm nhất, cần có người trợ giúp nhất sẽ hợp thời xuất hiện, tựa như một người nhiều năm chinh chiến trên biển, không e ngại kinh đào hải lãng, luôn có thể biến nguy thành an, là mọi năng lượng số trong quang minh chi tử. Giữa phu thê hỗ trợ tốt đẹp, hưởng thụ tình yêu ngọt ngào, mỗi ngày đều trải qua sinh hoạt thần tiên quyến lữ, nắm giữ tốt từ trường số Sinh Khí trong đời sống tình cảm sẽ là một đoạn hồi ức tuyệt đẹp. Từ trường Số Sinh khí trong tài vận là ý nghĩa là vô hạn quý nhân tương trợ, bởi vậy cho dù khi không trôi chảy, cũng sẽ có phúc khí, từ trường số Sinh Khí giống như Tử Vi Đấu Sổ Thiên Lương tinh, đều là gặp dữ hóa lành. Bình thường từ trường số Sinh Khí trong tài vận sẽ xuất hiện quý nhân, có tiền ngoài ý muốn, hoặc là kiểu vô tâm trồng liễu lại có tài, từ trường số Sinh Khí tài vận đối với tiền tài ít có khái niệm, không để ý tới tiền tài, là người it so đo.',
    uuDiem: 'Yên vui, tâm bình tĩnh đối đãi, quý nhân phù trợ, gặp sao yên vậy là từ trường năng lượng số Sinh Khí.',
    khuyetDiem: 'Vì bất cứ chuyện gì cũng đều không bắt buộc, chủ quan, sinh ra tâm ý không vững mạnh.',
    taiVan:
      'Quý nhân mang tài đến hoặc có tiền ngoài ý muốn, như trúng thưởng, đem tiền tiêu cho bạn bè, không giữ được tiền.',
    suNghiep:
      'Nhiều quý nhân trợ giúp, gặp dữ hóa lành, xuôi gió xuôi nước, thích hợp làm công tác xã hội, PR, tin người, nhưng lòng cầu tiến không đủ.',
    honNhan: 'Không cưỡng cầu, tùy duyên, không so đo, quan hệ hài hòa, hôn nhân ngọt ngào.',
    sucKhoe: 'Có bệnh dạ dày, tai mắt mũi, bị bệnh hay nhìn thoáng, không quan trọng, không muốn đi viện.',
    khuyenNghi: 'Lập kế hoạch, quản lý tài chính.',
  },
  'Diên Niên': {
    name: 'Diên Niên',
    nguHanh: 'Kim',
    lug: 'kim',
    chomSao: 'Vũ Khúc',
    dacDiem:
      'Người có năng lượng từ trường số Diên Niên thuộc về nhóm người lao tâm lao lực, họ có tinh thần trách nhiệm, chịu sức ép mạnh, cũng là cái mà những người có từ trường số khác không theo kịp, bởi vậy dễ quá độ vất vả lâu ngày mà xuất hiện bệnh tật, không chỉ ở bên ngoài là vai, cổ, khớp nối với hệ thống thần kinh mà còn trong tạng phủ, người có từ trường số Diên Niên cũng tương đối dễ xuất hiện các vấn đề về tinh thần, dễ mất ngủ. Thường là người lãnh đạo chúa tể một phương, bản thân có chủ trương, không dễ bị người thuyết phục, trừ phi năng lực kém hơn người kia, đối với sự vật có sức phán đoán cực mạnh, đối với tình cảm chấp nhất và thành thục, tâm địa thiện lương thuộc diện người thà thiếu không ẩu, có ý chí trách trời thương dân, xử lý sự việc theo hướng chính đạo, trời sinh tính chịu đựng siêu cường, người có từ trường số Diên Niên tương đối trường thọ, thuộc về dạng người không chịu ngồi yên, dù là trong công việc hay ở nhà, đều thích hoạt động.',
    uuDiem:
      'Hòa thuận, tốt cho sự nghiệp và ngoại giao. Gặp được sao này chính thì tài vận rất tốt, sống thọ, khỏe mạnh, vợ chồng hòa khí.',
    khuyetDiem:
      'Không dễ tiếp nhận ý kiến, đang xem xét thì có tác phong cường thế, tương đối ít quan tâm phản ứng của người khác, xử lý sự tình tương đối theo cái tôi, có bài bản tương đối khó biến báo, co dãn biên độ nhỏ, có ý nghĩ của mình, cái tôi cao muốn người khác theo ý mình, cố chấp khó hòa hợp.',
    taiVan: ' Vất vả kiếm tiền, tương đối giữ được tiền, thích tính toán tỉ mỉ, gọi là vắt cổ chày ra nước.',
    suNghiep:
      'Có năng lực chuyên nghiệp, làm lãnh đạo và kỹ thuật, mọi thứ tự thân, lao lực, áp lực lớn, thích chủ đạo, có thể một mình gánh vác một phương.',
    honNhan: 'Một lòng chuyên chú, yêu cầu cao, thả thiếu không ẩu, một nhà chi chủ.',
    sucKhoe:
      'Vất vả lâu ngày thành tật, dễ có bệnh về vai cổ, eo, giấc ngủ không tốt, rụng tóc, tinh thần. Cần lưu ý vì hay chiêu cảm các bệnh lý như: Dễ bị cơ- xương - khớp (tê bì tay chân, khớp, vôi hóa, gout, đau cổ vai gáy, thần kinh tọa)...',
    khuyenNghi: 'Giữ hòa khí, cẩn trọng pháp lý.',
  },
  'Phục Vị': {
    name: 'Phục Vị',
    nguHanh: 'Thổ',
    lug: 'tho',
    chomSao: 'Tả Phù',
    dacDiem:
      'Phục Vị - nhân cách đặc chất là bảo thủ, cố chấp, mâu thuẫn, cẩn thận suy nghĩ bị động, quá cẩn thận, nội tâm không cảm giác an toàn, sợ mạo hiểm, sợ bị thương tổn, tổn thất, trong sự nghiệp sẽ kiên nhẫn chờ đợi thời cơ, cũng bởi vì quá bảo thủ mà không dễ xuất hiện chuyển cơ, mất đi nhiều cơ hội, quá bảo thủ quan hệ, tình cảm có thể kiên nhẫn chờ đợi, không thích hợp làm các việc tinh tế.',
    uuDiem:
      'Có được sức chịu đựng, nghị lực người bình thưởng không có, lại có thể chờ đợi cơ hội một tiếng làm kinh người.Tiềm ẩn năng lực không phải từ trường số khác có thể so sánh.',
    khuyetDiem:
      'Không dễ biến động, vì không có cảm giác an toàn, xử lý sự tình thường lặp đi lặp lại khó lựa chọn, kiên nhẫn mâu thuẫn vì quá độ bảo thủ và cảm giác không an toàn, cần thường xuyên lời ngợi khen thay vì quở trách.',
    taiVan: 'Kiếm tiền hạnh khổ, thích cầm tiền lương cố định, thu nhập ổn định.',
    suNghiep:
      'Gò bó theo khuôn phép, không thay đổi, thích hợp việc làm có tính ổn định cao, theo công chức, đơn vị sự nghiệp, có tính nhẫn nại chờ đợi, nhưng có khi phục quá nhiều mà bỏ lỡ nhiều cơ hội tốt, cái này cũng là vì từ trường Phục Vị là quá bảo thủ chờ đợi, không dám có hành động. Dù cho có hành động, ngược lại là thất bại, nếu không nghe khuyên bảo, cứng rắn muốn làm, kết quả sẽ khiến mình càng thêm thương tâm.',
    honNhan:
      'Người từ trường Phục Vị đối với tình cảm không thích ôm trách nhiệm, tựa như cây xấu hổ, có gió thối cỏ lay lập tức đóng lại, đem mình giam lại, khẩn cầu đừng để mình bị bất cứ thương tổn gì, năng lượng từ trường Phục Vị đối với tình cảm dễ phong bế, đối phương cần kiên nhẫn tràn ngập ôn nhu yêu thương, tỉ mỉ giải khai tâm của họ thì người có từ trường Phục Vị mới có thể hoàn toàn thoải mái, mới có thể được đối phương thực tình đối đãi.',
    sucKhoe: 'Bệnh về tim, não, lo nghĩ, bệnh ẩn tính.',
    khuyenNghi: 'Mở rộng mạng lưới, tránh cô lập.',
  },
  'Ngũ Quỷ': {
    name: 'Ngũ Quỷ',
    nguHanh: 'Hỏa',
    lug: 'hoa',
    chomSao: 'Liêm Trinh',
    dacDiem:
      'Cá tính âm trầm, độc hành, làm việc khiến người không thể phỏng đoán, có song trọng nhân cách, thường có họa sát thân, ý đô xấu rất nhiếu, nhưng nội tâm yếu ớt lại thường cực đoan, là người rất hiện thực, dễ ly dị, chia tay hoặc ngoại tình, tương đối không định tính, tùy thời cai biến, không theo chính đạo, không đi chính thống khá rõ, cùng người ở chung dễ lập hội nhưng bụng dạ cực sâu. Chứng minh thư có từ trường Ngũ Quỷ hoặc từ trường hậu thiên có càng nhiều số Ngũ Quỷ thì không thể an ổn tại một vị trí, muốn đổi công việc, không cam lòng bình thản, nhiều ý đồ xấu. Có tài hoa là chuyện tốt, nhưng những người có Ngũ Quỷ từ trường đều có thể nhìn thấy tình cảm và cuộc sống thất lạc lên xuống, vì Ngũ Quỷ từ trường trong tình cảm cực thiếu cảm giác an toàn, nắm bắt được tâm sự của bọn họ là cực khó, người có từ trường Ngũ Quỷ rất đa nghi,cùng họ ở chung cần chuẩn bị về tâm lý, vì họ không tín nhiệm bất cứ ai.',
    uuDiem: 'Tài hoa dào dạt, tư tưởng hay thay đổi, phản ứng nhanh, học tập mạnh, khả năng tư duy ngược tốt.',
    khuyetDiem:
      'Không ổn định, rất dễ có họa sát thân, cần đặc biệt chú ý, năng lượng số Từ trường Ngũ quỷ càng lớn thì sinh ra bệnh tật, huyết quang ngoài ý muốn sẽ càng nghiêm trọng.',
    taiVan: 'Buôn bán, mệnh lý tông giáo là thích hợp.',
    suNghiep: 'Thường xuyên biến động, không an phận, làm các việc như buôn bán, công tác nhiều, tông giáo.',
    honNhan: 'Tinh cảm hay thay đổi, không an phận, dễ có quan hệ tay ba, ngoại tình, ly hôn.',
    sucKhoe:
      'Thường chiêu cảm các bệnh lý, vấn nạn cụ thể như: Dễ mắc các bệnh liên quan đến thần kinh (đầu nửa đầu, đau thái dương, tắc nghẽn dây thần kinh, thần kinh tọa, tuần hoàn máu...) tim mạch (huyết áp, suy nhược, yếu khí..), dễ chiêu cảm các vấn đề liên quan đế xô xát, tai nạn, máu huyết, lao ngục...',
    khuyenNghi: 'Chuẩn bị pháp lý, tránh thị phi.',
  },
  'Lục Sát': {
    name: 'Lục Sát',
    nguHanh: 'Thủy',
    lug: 'thuy',
    chomSao: 'Văn Khúc',
    dacDiem:
      'Gặp chuyện do dự, quá cẩn thận lại mâu thuẫn, duyên với người khác phái mạnh, nhưng không dễ nở hoa kết trái, lá mặt lá trái, lại thường biến khéo thành vụng, ngoại tình bởi vậy sinh ra. Lục Sát trong chuyện tình cảm khó dò xét nhất, lại khó mà dùng lẽ thường phán đoán, vì họ đối với tình cảm không quả quyết, có can đảm tiến lên lại tuỳ tiện lùi bước, người có số Lục Sát đều rất giỏi về ngoại giao, đây là chính diện hiệu ứng của số Lục Sát, là mặt trái cũng khá lợi hại, sẽ khốn khổ vì tình, là nhóm dễ tự sát u buồn, đồng thời cũng là nhóm dễ ly hôn hoặc ngoại tình, có thể giải thích đều là vì tình cảm dễ xảy ra vấn đề, trong tình huống giao hữu, cũng dễ xuất hiện bằng hữu kiểu này. Vận thế đến số Lục Sát, bản thân họ không ngừng tản mạn ra mị lực, hấp dẫn đối phương, thiên đào hoa chính là nói về số Lục Sát. Trong yêu đương nam nữ, đối phương có một cử chỉ quan tâm nhỏ bé nào cũng đề khiến họ cảm động rất lâu, tri kỷ đối đãi sẽ hòa tan tâm của Lục Sát, nếu làm vậy lâu dài có thể đem số Lục Sát toàn diện đưa vào trong cơ thể mình. Đây chính là cái gọi là Diên Niên chế Lục Sát. Nếu đã kết hôn,đến vận thế số Lục Sát sẽ là một giai đoạn thống khổ nhưng không nhất định ảnh hưởng đến hôn nhân mà cần tham khảo nhiều phương diện, không thể luận đơn nhất.',
    uuDiem: 'Tình cảm phong phú, duyên với người khác phái đặc biệt mạnh.',
    khuyetDiem:
      'Khốn khổ vì tình, dẫn đến tình kết bất an, quan hệ nhân mạch lại đột nhiên chuyển biến xấu, tình cảm hoặc hôn nhân không trôi chảy.',
    taiVan: 'Dựa vào quan hệ nhân mạch để kiếm tiền, tiêu tiền cho gia đình, nữ nhân, không giữ được tiền.',
    suNghiep: 'Quan hệ xã hội, ngoại giao, nghề phục vụ, ngành nghề nữ tính hoặc thích chưng diện,không thực muốn làm.',
    honNhan: 'Tâm tư cẩn thận mẫn cảm, duyên với người khác phái mạnh, dễ thiên đào hoa, cưới vì tình, dễ ngoại tình.',
    sucKhoe: 'Da, dạ dày, dễ bị u buồn, nóng nảy, bệnh tự kỷ.',
    khuyenNghi: 'Chuẩn hóa giấy tờ, tránh mâu thuẫn.',
  },
  'Họa Hại': {
    name: 'Họa Hại',
    nguHanh: 'Thổ',
    lug: 'tho',
    chomSao: 'Lộc Tồn',
    dacDiem:
      'Dễ gây gổ với mọi người, khẩu tài tuy tốt nhưng người khác khẩu phục tâm không phục, thích để tâm vào chuyện vụn vặt,trong công việc thường dễ xung động cậy mạnh,thích thành nhân vật chính,dễ cãi cọ, khéo léo, hoạt ngôn, xảo ngữ, nói chuyện chém gió như thần, mạnh miệng nhưng nội tâm lại yếu ớt khó chịu nổi một kích động, sức khỏe yếu, dễ có bệnh tiên thiên, dễ vì việc nhỏ mà sinh ra cãi vã..',
    uuDiem:
      'Miệng lưỡi lưu loát thao thao bất tuyệt, hùng biện là sở trường của từ trường số Họa Hại, kiếm cơm nhờ miệng lưỡi .',
    khuyetDiem:
      'Vì tính khí nóng này mà dễ dẫn tới cãi vã thị phi, trong quan hệ xã hội khó được người yêu mến, người dễ yếu, nhiều bệnh. Chỉ cần là tiến vào vận thế của từ trường số Họa Hại thì dù là nam hay nữ hôm đó sẽ cảm thấy yếu ốm, kể cà người trẻ tuổi cũng sẽ thấy lắm bệnh.',
    taiVan:
      'Mở miệng là được tài (thêm Thiên Y mới có) hoặc hướng người đòi tiền nhưng khó giữ được tiền, dễ vì cãi vã mà phá tài.',
    suNghiep:
      'Làm các công việc liên quan đến nói năng, nói nhiều làm ít, thích chỉ huy người khác làm việc, dễ cãi vã thị phi, hay oán trách.',
    sucKhoe:
      'Dễ có các bệnh ở khoang miệng, khí quản, yết hầu, tuyến bạch huyết, lồng ngực liên quan đến khí quản.Hao tổn tiết nguyên khí, dễ mệt mỏi, dễ bị chứng béo phì. ',
    honNhan: 'Đầu tiên thì ngon ngọt, sau đó hai bên dễ cãi vã thị phi, ly hôn.',
    khuyenNghi: 'Chuẩn hóa quy trình, checklist.',
  },
  'Tuyệt Mệnh': {
    name: 'Tuyệt Mệnh',
    nguHanh: 'Kim',
    lug: 'kim',
    chomSao: 'Phá Quân',
    dacDiem:
      'Sẽ không trung dung, cuộc sống lên bổng xuống trầm, lúc cao lúc thấp không ổn định, cực đoan, lạc quan hoặc bi quan lưỡng cực hóa, thường có chuyện tốt hoặc chuyện xấu phát sinh ngoài ý liệu. Dễ có vấn đề kiện cáo văn thư phát sinh. Tính cách bất chấp nguy hiểm, phản ứng nhanh đặc biệt khi làm việc, có khả năng phán đoán cực tốt, hay xử lý mọi việc theo cảm tính, chủ quan thành kiến sâu, trong đoàn thể thường là độc lai độc vãng, dễ được bạn bè sùng bái, nhưng thích một mình, tình cảm không dễ có kết quả, sau khi cưới năng lực cân đối gia đình cũng không giỏi, không dễ chia sẻ với bạn đời, hơi cực đoan, hay tự cho là đúng.',
    uuDiem:
      'Phản ứng nhanh, mẫn cảm mạnh đối với sự vật, quyết đoán, tâm địa mềm, thiện lương, thẳng tính, rất dễ tin tưởng bạn bè.',
    khuyetDiem:
      'Khá dễ phạm thượng kháng lệnh sếp,và quá mức chấp nhất, vì quá chấp nhất mà sinh ra lực cản. Dễ sốt ruột, thường chỉ trích người khác không phải, khiến bạn bè xa lánh, tự cho là đúng, không nghe khuyên bảo,trong tình cảm và hôn nhân thiếu hòa hợp.',
    taiVan:
      'Người có Tuyệt Mệnh dám liều. Việc kiếm tiền đối với người Tuyệt Mệnh đơn giản nhưng vất vã. Ở tài vận bọn họ hầu như là nhanh hơn người khác một bước, đây chính là một tiêu chuẩn đặc sắc của Tuyệt Mệnh, nhưng năng lực giữ tiền lại không giỏi, kiếm tiền không khó, thủ tài thì lại cần nhờ người khác.',
    suNghiep:
      'Làm về đầu tư, tài chính, cổ phiếu, hoặc tự mình lập nghiệp, dám liều, có tinh thần mạo hiểm, dễ có những quyết định cảm tính,',
    sucKhoe: 'Chú ý gan, thận, bệnh tiểu đường. Thậm chí tai nạn, ung thư?...',
    honNhan:
      'Dũng cảm truy cầu, nhưng năng lực cân đối kém, bất lợi cho hôn nhân, dễ ly hôn (trước hôn nhân rất lãng mạn, không thích hợp kết hôn), dám yêu dám hận.',
    khuyenNghi: 'Chuẩn hóa quy trình, checklist.',
  },
};

// -----------------------------
// 3) HÀM TIỆN ÍCH: parse digits & build groups (giữ logic cũ)
// -----------------------------
export function parseDigitsFromCCCD(cccd) {
  if (!cccd) return [];
  return String(cccd).replace(/\D/g, '').split('');
}

/**
 * buildGroupsFromCCCD(cccd)
 * - Giữ nguyên logic: bắt đầu ở vị trí digit không phải 0/5, nhóm theo vòng tròn
 * - Trả về mảng group objects: { group: '802', start: idxStart, end: idxEnd, originalIdxList: [ ... ] }
 */
export function buildGroupsFromCCCD(cccd, options = {}) {
  const skipDigits = options.skipDigits || ['0', '5'];
  const digits = parseDigitsFromCCCD(cccd);
  const n = digits.length;
  if (n === 0) return [];

  const starts = [];
  for (let i = 0; i < n; i++) {
    if (!skipDigits.includes(digits[i])) starts.push(i);
  }
  if (starts.length === 0) {
    const fallback = [];
    for (let i = 0; i < n; i += 2) {
      const a = digits[i] || '';
      const b = digits[(i + 1) % n] || '';
      fallback.push({ group: a + b, start: i, end: (i + 1) % n, originalIdxList: [i, (i + 1) % n] });
    }
    return fallback;
  }

  const groups = [];
  for (const i of starts) {
    let j = (i + 1) % n;
    while (skipDigits.includes(digits[j]) && j !== i) j = (j + 1) % n;
    if (j === i) {
      const start = i;
      const end = (i + 1) % n;
      const originalIdxList = [start, end];
      groups.push({ group: digits[start] + digits[end], start, end, originalIdxList });
    } else {
      let s = '';
      let k = i;
      const originalIdxList = [];
      s += digits[k];
      originalIdxList.push(k);
      while (k !== j) {
        k = (k + 1) % n;
        s += digits[k];
        originalIdxList.push(k);
      }
      groups.push({ group: s, start: i, end: j, originalIdxList });
    }
  }
  return groups;
}

export function getAgeSegments() {
  return [
    { start: 0, end: 10, label: '0 ~ 10' },
    { start: 10, end: 15, label: '10 ~ 15' },
    { start: 15, end: 20, label: '15 ~ 20' },
    { start: 20, end: 25, label: '20 ~ 25' },
    { start: 25, end: 30, label: '25 ~ 30' },
    { start: 30, end: 35, label: '30 ~ 35' },
    { start: 35, end: 40, label: '35 ~ 40' },
    { start: 40, end: 45, label: '40 ~ 45' },
    { start: 45, end: 50, label: '45 ~ 50' },
    { start: 50, end: 55, label: '50 ~ 55' },
    { start: 55, end: 60, label: '55 ~ 60' },
    { start: 60, end: 65, label: '60 ~ 65' },
  ];
}

// -----------------------------
// 4) generate variants (remove 0/5) - dùng khi cần
// -----------------------------
export function generateZeroFiveCleanVariants(s) {
  const g = String(s || '').replace(/\D/g, '');
  const set = new Set();
  if (!g) return [];
  set.add(g);
  const removed = g.replace(/[05]/g, '');
  if (removed) set.add(removed);
  const removedLeading = g.replace(/^[05]+/, '');
  if (removedLeading) set.add(removedLeading);
  for (let i = 0; i + 2 <= removed.length; i++) set.add(removed.slice(i, i + 2));
  for (let i = 0; i + 2 <= g.length; i++) set.add(g.slice(i, i + 2));
  return Array.from(set);
}

// -----------------------------
// 5) lookupEnergyForGroup (giữ thứ tự ưu tiên)
// -----------------------------
export function lookupEnergyForGroup(groupStr) {
  if (!groupStr) return { energyName: null, kind: 'unknown' };
  const g = String(groupStr).replace(/\D/g, '');

  // 5-digit
  // if (g.length >= 5) {
  //   for (let i = 0; i + 5 <= g.length; i++) {
  //     const s5 = g.slice(i, i + 5);
  //     if (FIVE_DIGIT_MAP[s5]) return { energyName: FIVE_DIGIT_MAP[s5], kind: '5-digit', key: s5 };
  //   }
  // }

  // 3-digit
  if (g.length >= 3) {
    for (let i = 0; i + 3 <= g.length; i++) {
      const s3 = g.slice(i, i + 3);
      const bo3so = analyzePhoneEnergy(s3);
      if (bo3so?.triplets?.length > 0) return { energyName: bo3so, kind: '3-digit', key: s3 };
    }
  }

  // variants (remove 0/5)
  const variants = generateZeroFiveCleanVariants(g).sort((a, b) => b.length - a.length);
  for (const v of variants) {
    if (!v) continue;
    if (v.length >= 3) {
      for (let i = 0; i + 3 <= v.length; i++) {
        const sub3 = v.slice(i, i + 3);
        const bo3so = analyzePhoneEnergy(sub3);
        if (bo3so?.triplets?.length > 0) return { energyName: bo3so, kind: '3-variant', key: sub3, variant: v };
      }
    }
    if (v.length >= 2) {
      const last2 = v.slice(-2);
      if (TWO_DIGIT_MAP[last2]) return { energyName: TWO_DIGIT_MAP[last2], kind: '2-var-last', key: last2, variant: v };
      const first2 = v.slice(0, 2);
      if (TWO_DIGIT_MAP[first2])
        return { energyName: TWO_DIGIT_MAP[first2], kind: '2-var-first', key: first2, variant: v };
      for (let i = 0; i + 2 <= v.length; i++) {
        const s2 = v.slice(i, i + 2);
        if (TWO_DIGIT_MAP[s2]) return { energyName: TWO_DIGIT_MAP[s2], kind: '2-var-sub', key: s2, variant: v };
      }
    }
  }

  // 2-digit direct
  for (let i = 0; i + 2 <= g.length; i++) {
    const sub2 = g.slice(i, i + 2);
    if (TWO_DIGIT_MAP[sub2]) return { energyName: TWO_DIGIT_MAP[sub2], kind: '2-sub-original', key: sub2 };
  }

  return { energyName: null, kind: 'unknown', raw: g };
}

// -----------------------------
// 6) Build concat string FROM GROUPS (important fix)
//    - concatGroups = join groupsDetailed.group in order, repeat until enough chars
//    - produce indexToGroup[] and indexToOriginal[] to know membership
// -----------------------------
// -----------------------------
// 6) Build concat string FROM GROUPS (reworked)
//    - Khôi phục chuỗi gốc từ originalIdxList
//    - Lặp chuỗi gốc để tạo concat
//    - Tạo ánh xạ chủ sở hữu cặp (pairOwnerByConcatStart) để map năng lượng theo group đúng
//      + cặp nội bộ trong group -> thuộc group đó
//      + cặp qua "chuỗi 0/5 đầu chuỗi gốc" -> gán cho group đầu tiên ngay sau run 0/5
// -----------------------------
export function buildConcatFromGroups(groupsDetailed, neededChars = 24) {
  if (!groupsDetailed || groupsDetailed.length === 0) {
    return { concat: '', indexToGroup: [], indexToOriginal: [], baseCycle: '', pairOwnerByConcatStart: [] };
  }

  // 1) Xác định độ dài chuỗi gốc và khôi phục từng ký tự theo index gốc
  const allIdx = [];
  groupsDetailed.forEach((g) => (g.originalIdxList || []).forEach((i) => allIdx.push(i)));
  const n = Math.max(...allIdx) + 1;

  const baseDigits = new Array(n);
  // điền ký tự gốc theo index (nếu có trùng, ký tự phải trùng nhau)
  groupsDetailed.forEach((g) => {
    const chars = (g.group || '').split('');
    const idxs = g.originalIdxList || [];
    for (let k = 0; k < Math.min(chars.length, idxs.length); k++) {
      const pos = idxs[k];
      if (baseDigits[pos] == null) {
        baseDigits[pos] = chars[k];
      } else if (baseDigits[pos] !== chars[k]) {
        // nếu có sai lệch (hiếm), ưu tiên lần điền đầu tiên
        // có thể log nếu cần debug
      }
    }
  });

  // phòng khi còn ô trống (không mong muốn) => điền '0' để tránh lỗi
  for (let i = 0; i < n; i++) {
    if (baseDigits[i] == null) baseDigits[i] = '0';
  }

  const base = baseDigits.join('');

  // 2) Xác định "group đầu tiên" sau chuỗi 0/5 đầu chuỗi gốc (nếu có)
  const isSkip = (ch) => ch === '0' || ch === '5';
  let firstNonSkipIdx = -1;
  let leadingSkipRunLastIdx = -1; // index cuối cùng của dãy 0/5 đầu chuỗi
  for (let i = 0; i < n; i++) {
    if (isSkip(baseDigits[i])) {
      leadingSkipRunLastIdx = i;
    } else {
      firstNonSkipIdx = i;
      break;
    }
  }

  // Tìm group có originalIdxList[0] === firstNonSkipIdx (group đầu tiên thực sự)
  let firstGroupIdx = null;
  if (firstNonSkipIdx !== -1) {
    for (let gi = 0; gi < groupsDetailed.length; gi++) {
      const g = groupsDetailed[gi];
      if (g && g.originalIdxList && g.originalIdxList.length > 0 && g.originalIdxList[0] === firstNonSkipIdx) {
        firstGroupIdx = gi;
        break;
      }
    }
  }

  // 3) Tạo "yêu cầu sở hữu cặp" (claims) ở từng vị trí bắt đầu cặp trong chuỗi gốc
  // claims[i] = danh sách { gi, priority } đòi quyền cặp (i -> i+1)
  const claims = Array.from({ length: n }, () => []);

  // 3a) cặp nội bộ của từng group
  groupsDetailed.forEach((g, gi) => {
    const idxs = g.originalIdxList || [];
    for (let t = 0; t + 1 < idxs.length; t++) {
      const a = idxs[t];
      claims[a].push({ gi, priority: 1 }); // nội bộ
    }
  });

  // 3b) cặp đặc biệt tại "đầu chuỗi gốc": nếu có dãy 0/5 dẫn vào group đầu tiên
  // ví dụ base: 0 6 8 … -> cặp (0,1) phải thuộc group có start = 1 (tức '68')
  if (firstGroupIdx !== null && leadingSkipRunLastIdx !== -1) {
    const pairStartAt = leadingSkipRunLastIdx; // cặp (leadingSkipRunLastIdx -> firstNonSkipIdx)
    claims[pairStartAt].push({ gi: firstGroupIdx, priority: 3 }); // ưu tiên cao nhất
  }

  // 4) Chốt chủ sở hữu cặp theo priority
  const pairOwnerBase = new Array(n).fill(null); // group index hoặc null
  for (let i = 0; i < n; i++) {
    if (!claims[i] || claims[i].length === 0) continue;
    let best = claims[i][0];
    for (let c = 1; c < claims[i].length; c++) {
      if (claims[i][c].priority > best.priority) best = claims[i][c];
    }
    pairOwnerBase[i] = best.gi;
  }

  // 5) Dựng concat bằng cách lặp base
  let concat = '';
  const indexToOriginal = [];
  const indexToGroup = []; // không dùng để quyết định cặp nữa; để null nhằm tránh ảnh hưởng logic cũ
  const pairOwnerByConcatStart = [];

  while (concat.length < neededChars + 2) {
    for (let k = 0; k < n && concat.length < neededChars + 2; k++) {
      concat += baseDigits[k];
      indexToOriginal.push(k);
      indexToGroup.push(null); // để rỗng; mapping theo cặp sẽ dùng pairOwnerByConcatStart
      pairOwnerByConcatStart.push(pairOwnerBase[k]);
    }
  }

  return {
    concat,
    indexToGroup,
    indexToOriginal,
    baseCycle: base,
    pairOwnerByConcatStart,
  };
}

// -----------------------------
// 7) generate overlapping pairs from concat
// -----------------------------
export function generatePairsFromConcat(concat, neededPairs = 11) {
  const pairs = [];
  for (let i = 0; i + 1 < concat.length && pairs.length < neededPairs; i++) {
    pairs.push({ pair: concat.slice(i, i + 2), startIdx: i, endIdx: i + 1 });
  }
  return pairs;
}

// -----------------------------
// 8) MAP pair -> energy (PRIORITY group membership)
// -----------------------------
// -----------------------------
// 8) MAP pair -> energy (ưu tiên chủ sở hữu cặp do buildConcatFromGroups cung cấp)
// -----------------------------
export function mapPairToEnergyFromConcat(
  pairObj,
  concat,
  indexToGroup,
  groupsDetailed,
  pairOwnerByConcatStart, // <— mới: mảng chủ sở hữu cặp theo vị trí bắt đầu trong concat
) {
  const { pair, startIdx, endIdx } = pairObj;

  // 0) Ưu tiên: nếu đã có chủ sở hữu cặp rõ ràng -> lấy năng lượng theo group đó
  if (pairOwnerByConcatStart && typeof pairOwnerByConcatStart[startIdx] === 'number') {
    const gi = pairOwnerByConcatStart[startIdx];
    const groupObj = groupsDetailed[gi];
    if (groupObj) {
      const lookup = lookupEnergyForGroup(groupObj.group);
      if (lookup && lookup.energyName) {
        return {
          energyName: lookup.energyName,
          kind: 'pair-owner',
          groupStr: groupObj.group,
          key: lookup.key,
        };
      }
    }
    // nếu vì lý do gì lookup fail, tiếp tục fallback bên dưới
  }

  // 1) fallback cũ: nếu cả 2 vị trí thuộc cùng group index -> dùng năng lượng group
  const groupStart = indexToGroup[startIdx];
  const groupEnd = indexToGroup[endIdx];
  if (typeof groupStart !== 'undefined' && groupStart !== null && groupStart === groupEnd) {
    const groupObj = groupsDetailed[groupStart];
    if (groupObj) {
      const lookup = lookupEnergyForGroup(groupObj.group);
      if (lookup && lookup.energyName) {
        return { energyName: lookup.energyName, kind: 'group-priority', groupStr: groupObj.group, key: lookup.key };
      }
    }
  }

  // 2) lookup trực tiếp theo cặp
  if (TWO_DIGIT_MAP[pair]) {
    return { energyName: TWO_DIGIT_MAP[pair], kind: '2-direct', key: pair };
  }

  // 3) thử 3-digit context
  for (let i = Math.max(0, startIdx - 2); i <= startIdx + 1; i++) {
    if (i >= 0 && i + 3 <= concat.length) {
      const s3 = concat.slice(i, i + 3);
      const bo3so = analyzePhoneEnergy(s3);
      if (bo3so?.triplets?.length > 0) {
        return { energyName: bo3so, kind: '3-context', key: s3 };
      }
      const variants = generateZeroFiveCleanVariants(s3);
      for (const v of variants) {
        if (v.length >= 2 && TWO_DIGIT_MAP[v.slice(-2)]) {
          return { energyName: TWO_DIGIT_MAP[v.slice(-2)], kind: '2-variant-context', key: v.slice(-2) };
        }
      }
    }
  }

  // 4) không xác định
  return { energyName: null, kind: 'unknown', raw: pair };
}

// -----------------------------
// 9) assignPairsToAgeSegments (tạo bảng Đại vận)
// -----------------------------
// -----------------------------
// 9) assignPairsToAgeSegments (update: truyền pairOwnerByConcatStart vào mapPairToEnergyFromConcat)
// -----------------------------
export function assignPairsToAgeSegmentsFromGroups(groupsDetailed, neededPairs = 11) {
  const segments = getAgeSegments();
  const needed = Math.min(segments.length, neededPairs);

  const { concat, indexToGroup, indexToOriginal, pairOwnerByConcatStart } = buildConcatFromGroups(
    groupsDetailed,
    needed * 2 + 4,
  );
  const pairs = generatePairsFromConcat(concat, needed);

  const assigned = pairs.map((p, i) => {
    const mapped = mapPairToEnergyFromConcat(
      p,
      concat,
      indexToGroup,
      groupsDetailed,
      pairOwnerByConcatStart, // <— dùng chủ sở hữu cặp để ra group chính xác
    );
    return {
      index: i,
      segment: segments[i],
      pair: p.pair,
      mapped,
      groupIdxStart: indexToGroup[p.startIdx],
      groupIdxEnd: indexToGroup[p.endIdx],
      concat,
      startIdx: p.startIdx,
      endIdx: p.endIdx,
      originalStartIdx: indexToOriginal[p.startIdx],
    };
  });

  return { assigned, concat, indexToGroup, indexToOriginal };
}

// -----------------------------
// 10) computeAgeFromBirth & getCurrentSegmentIndex
// -----------------------------
export function computeAgeFromBirth({ day = 1, month = 1, year = 2000 } = {}) {
  const now = new Date();
  const birth = new Date(year, month - 1, Math.max(1, day));
  let age = now.getFullYear() - birth.getFullYear();
  const thisYearBirth = new Date(now.getFullYear(), birth.getMonth(), birth.getDate());
  if (now < thisYearBirth) age -= 1;
  if (age < 0) age = 0;
  return { age };
}

export function getCurrentSegmentIndex(age) {
  const segments = getAgeSegments();
  for (let i = 0; i < segments.length; i++) {
    const seg = segments[i];
    const next = segments[i + 1];
    if (!next) {
      if (age >= seg.start && age <= seg.end) return i;
    } else {
      if (age >= seg.start && age < next.start) return i;
    }
  }
  return 0;
}

// -----------------------------
// 11) analyzeCCCDFull (API cho UI) - tổng hợp
// -----------------------------
export function analyzeCCCDFull(cccd, birthInfo = { day: 1, month: 1, year: 2000 }) {
  const digits = parseDigitsFromCCCD(cccd);
  const groupsDetailed = buildGroupsFromCCCD(cccd);
  const groupStrings = groupsDetailed.map((g) => g.group);
  const { assigned, concat, indexToGroup, indexToOriginal } = assignPairsToAgeSegmentsFromGroups(
    groupsDetailed,
    getAgeSegments().length,
  );
  const freq = {};
  assigned.forEach((a) => {
    const nm = a.mapped && a.mapped.energyName ? a.mapped.energyName : 'Không xác định';
    freq[nm] = (freq[nm] || 0) + 1;
  });

  const freqSorted = Object.entries(freq).sort((a, b) => b[1] - a[1]);
  const ageInfo = computeAgeFromBirth(birthInfo);
  const currentSegmentIndex = getCurrentSegmentIndex(ageInfo.age);
  return {
    cccd,
    digits,
    groupsDetailed,
    groupStrings,
    concat,
    indexToGroup,
    indexToOriginal,
    assigned,
    freq,
    freqSorted,
    ageInfo,
    currentSegmentIndex,
    currentSegment: getAgeSegments()[currentSegmentIndex],
  };
}

// -----------------------------
// 12) analyzePhoneEnergy (SDT) - tổng hợp
// -----------------------------

export function analyzePhoneEnergy(phoneNumber) {
  let clean = phoneNumber.replace(/\D/g, ''); // chỉ giữ số

  // bỏ số 0 ở đầu (nếu có)
  if (clean.startsWith('0')) {
    clean = clean.substring(1);
  }

  const pairs = [];
  const triplets = [];

  // tìm vị trí số hợp lệ (≠ 0,5)
  function nextValidIndex(str, start) {
    for (let i = start; i < str.length; i++) {
      if (str[i] !== '0' && str[i] !== '5') {
        return i;
      }
    }
    return -1;
  }

  // ====== CẶP ======
  for (let i = 0; i < clean.length; i++) {
    if (clean[i] === '0' || clean[i] === '5') continue;

    const j = nextValidIndex(clean, i + 1);
    if (j !== -1) {
      const subDisplay = clean.substring(i, j + 1); // hiển thị nguyên cụm gốc
      const subEnergy = clean[i] + clean[j]; // dùng số bỏ 0,5 để tính
      const energyName = TWO_DIGIT_MAP[subEnergy] || null;

      pairs.push({ groupStr: subDisplay, energyName });
    }
  }

  // ====== BỘ 3 ======
  for (let i = 0; i < clean.length; i++) {
    if (clean[i] === '0' || clean[i] === '5') continue;

    const j = nextValidIndex(clean, i + 1);
    if (j === -1) continue;

    const k = nextValidIndex(clean, j + 1);
    if (k === -1) continue;

    const subDisplay = clean.substring(i, k + 1); // hiển thị nguyên cụm gốc
    const subEnergy = clean[i] + clean[j] + clean[k]; // dùng số bỏ 0,5 để tính
    const energyName = analyzeThreeDigits(subEnergy);

    if (energyName) {
      triplets.push({ groupStr: subDisplay, energyName });
    }
  }

  return {
    concat: clean,
    pairs,
    triplets,
  };
}

// Hàm phân tích 3 số thành ý nghĩa năng lượng
export function analyzeThreeDigits(triplet) {
  if (!/^\d{3}$/.test(triplet)) return null; // chỉ nhận đúng 3 số

  const firstPair = triplet.substring(0, 2); // 2 số đầu
  const secondPair = triplet.substring(1, 3); // 2 số cuối

  const firstEnergy = TWO_DIGIT_MAP[firstPair];
  const secondEnergy = TWO_DIGIT_MAP[secondPair];

  if (firstEnergy && secondEnergy) {
    // nếu cả 2 đều có trong map
    if (firstEnergy === secondEnergy) {
      return `${firstEnergy} + ${secondEnergy}`;
    }
    return `${firstEnergy} + ${secondEnergy}`;
  }

  return null; // nếu không match được thì bỏ qua
}

/** =====================
 *  Helpers chung
 * ===================== */
const CAN = ['Giáp', 'Ất', 'Bính', 'Đinh', 'Mậu', 'Kỷ', 'Canh', 'Tân', 'Nhâm', 'Quý'];
const CHI = ['Tý', 'Sửu', 'Dần', 'Mão', 'Thìn', 'Tỵ', 'Ngọ', 'Mùi', 'Thân', 'Dậu', 'Tuất', 'Hợi'];

// 1984 = Giáp Tý = index 0
function sexagenaryIndex(year) {
  let idx = (year - 1984) % 60;
  if (idx < 0) idx += 60;
  return idx;
}

function getCanChiYear(year) {
  const idx = sexagenaryIndex(year);
  const can = CAN[idx % 10];
  const chi = CHI[idx % 12];
  return { name: `${can} ${chi}`, can, chi, index60: idx };
}

/** =====================
 *  NẠP ÂM 60 HOA GIÁP
 * ===================== */

// Thứ tự theo chu kỳ 60 năm, 2 năm liền nhau chia chung một nạp âm.
export const NAP_AM_60 = [
  { canChi: 'Giáp Tý', menhct: 'Hải Trung Kim', menh: 'Kim' },
  { canChi: 'Ất Sửu', menhct: 'Hải Trung Kim', menh: 'Kim' },
  { canChi: 'Bính Dần', menhct: 'Lư Trung Hỏa', menh: 'Hỏa' },
  { canChi: 'Đinh Mão', menhct: 'Lư Trung Hỏa', menh: 'Hỏa' },
  { canChi: 'Mậu Thìn', menhct: 'Đại Lâm Mộc', menh: 'Mộc' },
  { canChi: 'Kỷ Tỵ', menhct: 'Đại Lâm Mộc', menh: 'Mộc' },
  { canChi: 'Canh Ngọ', menhct: 'Lộ Bàng Thổ', menh: 'Thổ' },
  { canChi: 'Tân Mùi', menhct: 'Lộ Bàng Thổ', menh: 'Thổ' },
  { canChi: 'Nhâm Thân', menhct: 'Kiếm Phong Kim', menh: 'Kim' },
  { canChi: 'Quý Dậu', menhct: 'Kiếm Phong Kim', menh: 'Kim' },
  { canChi: 'Giáp Tuất', menhct: 'Sơn Đầu Hỏa', menh: 'Hỏa' },
  { canChi: 'Ất Hợi', menhct: 'Sơn Đầu Hỏa', menh: 'Hỏa' },
  { canChi: 'Bính Tý', menhct: 'Giáng Hạ Thủy', menh: 'Thủy' },
  { canChi: 'Đinh Sửu', menhct: 'Giáng Hạ Thủy', menh: 'Thủy' },
  { canChi: 'Mậu Dần', menhct: 'Thành Đầu Thổ', menh: 'Thổ' },
  { canChi: 'Kỷ Mão', menhct: 'Thành Đầu Thổ', menh: 'Thổ' },
  { canChi: 'Canh Thìn', menhct: 'Bạch Lạp Kim', menh: 'Kim' },
  { canChi: 'Tân Tỵ', menhct: 'Bạch Lạp Kim', menh: 'Kim' },
  { canChi: 'Nhâm Ngọ', menhct: 'Dương Liễu Mộc', menh: 'Mộc' },
  { canChi: 'Quý Mùi', menhct: 'Dương Liễu Mộc', menh: 'Mộc' },
  { canChi: 'Giáp Thân', menhct: 'Tuyền Trung Thủy', menh: 'Thủy' },
  { canChi: 'Ất Dậu', menhct: 'Tuyền Trung Thủy', menh: 'Thủy' },
  { canChi: 'Bính Tuất', menhct: 'Ốc Thượng Thổ', menh: 'Thổ' },
  { canChi: 'Đinh Hợi', menhct: 'Ốc Thượng Thổ', menh: 'Thổ' },
  { canChi: 'Mậu Tý', menhct: 'Tích Lịch Hỏa', menh: 'Hỏa' },
  { canChi: 'Kỷ Sửu', menhct: 'Tích Lịch Hỏa', menh: 'Hỏa' },
  { canChi: 'Canh Dần', menhct: 'Tùng Bách Mộc', menh: 'Mộc' },
  { canChi: 'Tân Mão', menhct: 'Tùng Bách Mộc', menh: 'Mộc' },
  { canChi: 'Nhâm Thìn', menhct: 'Trường Lưu Thủy', menh: 'Thủy' },
  { canChi: 'Quý Tỵ', menhct: 'Trường Lưu Thủy', menh: 'Thủy' },
  { canChi: 'Giáp Ngọ', menhct: 'Sa Trung Kim', menh: 'Kim' },
  { canChi: 'Ất Mùi', menhct: 'Sa Trung Kim', menh: 'Kim' },
  { canChi: 'Bính Thân', menhct: 'Sơn Hạ Hỏa', menh: 'Hỏa' },
  { canChi: 'Đinh Dậu', menhct: 'Sơn Hạ Hỏa', menh: 'Hỏa' },
  { canChi: 'Mậu Tuất', menhct: 'Bình Địa Mộc', menh: 'Mộc' },
  { canChi: 'Kỷ Hợi', menhct: 'Bình Địa Mộc', menh: 'Mộc' },
  { canChi: 'Canh Tý', menhct: 'Bích Thượng Thổ', menh: 'Thổ' },
  { canChi: 'Tân Sửu', menhct: 'Bích Thượng Thổ', menh: 'Thổ' },
  { canChi: 'Nhâm Dần', menhct: 'Kim Bạch Kim', menh: 'Kim' },
  { canChi: 'Quý Mão', menhct: 'Kim Bạch Kim', menh: 'Kim' },
  { canChi: 'Giáp Thìn', menhct: 'Phúc Đăng Hỏa', menh: 'Hỏa' },
  { canChi: 'Ất Tỵ', menhct: 'Phúc Đăng Hỏa', menh: 'Hỏa' },
  { canChi: 'Bính Ngọ', menhct: 'Thiên Hà Thủy', menh: 'Thủy' },
  { canChi: 'Đinh Mùi', menhct: 'Thiên Hà Thủy', menh: 'Thủy' },
  { canChi: 'Mậu Thân', menhct: 'Đại Trạch Thổ', menh: 'Thổ' },
  { canChi: 'Kỷ Dậu', menhct: 'Đại Trạch Thổ', menh: 'Thổ' },
  { canChi: 'Canh Tuất', menhct: 'Thoa Xuyến Kim', menh: 'Kim' },
  { canChi: 'Tân Hợi', menhct: 'Thoa Xuyến Kim', menh: 'Kim' },
  { canChi: 'Nhâm Tý', menhct: 'Tang Đố Mộc', menh: 'Mộc' },
  { canChi: 'Quý Sửu', menhct: 'Tang Đố Mộc', menh: 'Mộc' },
  { canChi: 'Giáp Dần', menhct: 'Đại Khê Thủy', menh: 'Thủy' },
  { canChi: 'Ất Mão', menhct: 'Đại Khê Thủy', menh: 'Thủy' },
  { canChi: 'Bính Thìn', menhct: 'Sa Trung Thổ', menh: 'Thổ' },
  { canChi: 'Đinh Tỵ', menhct: 'Sa Trung Thổ', menh: 'Thổ' },
  { canChi: 'Mậu Ngọ', menhct: 'Thiên Thượng Hỏa', menh: 'Hỏa' },
  { canChi: 'Kỷ Mùi', menhct: 'Thiên Thượng Hỏa', menh: 'Hỏa' },
  { canChi: 'Canh Thân', menhct: 'Thạch Lựu Mộc', menh: 'Mộc' },
  { canChi: 'Tân Dậu', menhct: 'Thạch Lựu Mộc', menh: 'Mộc' },
  { canChi: 'Nhâm Tuất', menhct: 'Đại Hải Thủy', menh: 'Thủy' },
  { canChi: 'Quý Hợi', menhct: 'Đại Hải Thủy', menh: 'Thủy' },
];

function getNapAmByYear(year) {
  const { index60 } = getCanChiYear(year);
  return NAP_AM_60[index60]?.menhct;
}

// Hàm tính Can Chi + Nạp Âm
export function getMenhByYear(year) {
  const canIndex = (year + 6) % 10; // Giáp Tý 1984
  const chiIndex = (year + 8) % 12;
  const canChi = `${CAN[canIndex]} ${CHI[chiIndex]}`;

  const menhObj = NAP_AM_60.find((item) => item.canChi === canChi);

  return menhObj
    ? { year, menh: menhObj.menh, menhct: menhObj.menhct }
    : { year, menh: 'Không rõ', menhct: 'Không rõ' };
}
/** =====================
 *  CUNG MỆNH (BÁT TRẠCH – KUA)
 * ===================== */
/* Bảng ánh xạ KUA -> Cung (5 là special case) */
const KUA_TO_CUNG = {
  1: 'Khảm',
  2: 'Khôn',
  3: 'Chấn',
  4: 'Tốn',
  5: { nam: 'Khôn', nu: 'Cấn' }, // xử lý đặc biệt
  6: 'Càn',
  7: 'Đoài',
  8: 'Cấn',
  9: 'Ly',
};

function digitalRoot(n) {
  n = Math.abs(Math.trunc(Number(n) || 0));
  let s = String(n)
    .split('')
    .reduce((a, b) => a + Number(b), 0);
  while (s > 9) {
    s = String(s)
      .split('')
      .reduce((a, b) => a + Number(b), 0);
  }
  return s; // 1..9
}

function normalizeKua(kua) {
  kua = Number(kua);
  if (!Number.isFinite(kua)) return null;
  while (kua > 9) kua -= 9;
  while (kua <= 0) kua += 9;
  return kua;
}

/**
 * getCungMenh(year, gender)
 *  - year: NĂM ÂM LỊCH (number)
 *  - gender: 'nam' | 'nu'
 *
 * Trả về: { lunarYear: year, dr, kua, cung }
 */
export function getCungMenh(year, gender = 'nam') {
  const y = Number(year);
  if (!Number.isFinite(y)) return { error: 'Invalid year', input: year };

  const dr = digitalRoot(y);

  // Công thức đã chỉnh (linh động cho mọi năm)
  let kua = gender === 'nam' ? 11 - dr : dr + 4;

  // chuẩn hoá về 1..9
  kua = normalizeKua(kua);

  // xử lý special = 5 theo quy ước
  if (kua === 5) {
    kua = gender === 'nam' ? 2 : 8;
  }

  const mapVal = KUA_TO_CUNG[kua];
  const cung = typeof mapVal === 'string' ? mapVal : gender === 'nam' ? mapVal.nam : mapVal.nu;
  return cung;
}
/** =====================
 *  24 TIẾT KHÍ (mốc ngày chuẩn)
 *  Chọn tiết khí "đang hiệu lực" = mốc gần nhất <= ngày hiện tại.
 * ===================== */
const SOLAR_TERMS = [
  { name: 'Tiểu Hàn', m: 1, d: 5 },
  { name: 'Đại Hàn', m: 1, d: 20 },
  { name: 'Lập Xuân', m: 2, d: 4 },
  { name: 'Vũ Thủy', m: 2, d: 19 },
  { name: 'Kinh Trập', m: 3, d: 6 },
  { name: 'Xuân Phân', m: 3, d: 21 },
  { name: 'Thanh Minh', m: 4, d: 5 },
  { name: 'Cốc Vũ', m: 4, d: 20 },
  { name: 'Lập Hạ', m: 5, d: 6 },
  { name: 'Tiểu Mãn', m: 5, d: 21 },
  { name: 'Mang Chủng', m: 6, d: 6 },
  { name: 'Hạ Chí', m: 6, d: 21 },
  { name: 'Tiểu Thử', m: 7, d: 7 },
  { name: 'Đại Thử', m: 7, d: 23 },
  { name: 'Lập Thu', m: 8, d: 8 },
  { name: 'Xử Thử', m: 8, d: 23 },
  { name: 'Bạch Lộ', m: 9, d: 8 },
  { name: 'Thu Phân', m: 9, d: 23 },
  { name: 'Hàn Lộ', m: 10, d: 8 },
  { name: 'Sương Giáng', m: 10, d: 23 },
  { name: 'Lập Đông', m: 11, d: 7 },
  { name: 'Tiểu Tuyết', m: 11, d: 22 },
  { name: 'Đại Tuyết', m: 12, d: 7 },
  { name: 'Đông Chí', m: 12, d: 21 },
];

function getTietKhiName(day, month, year) {
  // Tìm mốc SOLAR_TERMS gần nhất nhưng không vượt quá (month, day)
  let current = SOLAR_TERMS[0].name;

  for (let i = 0; i < SOLAR_TERMS.length; i++) {
    const tk = SOLAR_TERMS[i];
    if (month > tk.m || (month === tk.m && day >= tk.d)) {
      current = tk.name;
    }
  }

  // Lấy tháng AL để show "(tháng x)" – theo lịch âm của ngày DL nhập
  let lunarMonth = '';
  try {
    const { lMonth } = solarlunar.solar2lunar(year, month, day);
    lunarMonth = ` (tháng ${lMonth})`;
  } catch (e) {
    lunarMonth = ''; // fallback nếu thiếu lib
  }

  return `${current}${lunarMonth}`;
}

/** =====================
 *  Giờ sinh
 * ===================== */
function parseChiFromHourLabel(hourLabel) {
  if (!hourLabel) return null;
  const chi = hourLabel.split(' ')[0]; // "Mão (05h-07h)" -> "Mão"
  const idx = CHI.indexOf(chi);
  return idx >= 0 ? { chi, chiIndex: idx } : null;
}

/**
 * Nếu thư viện solarlunar trả về gzDay (can chi ngày) thì suy ra Thiên can của giờ:
 *  Nhóm can ngày:
 *   - (Giáp, Kỷ)  -> Tý bắt đầu Giáp
 *   - (Ất, Canh)  -> Tý bắt đầu Bính
 *   - (Bính, Tân) -> Tý bắt đầu Mậu
 *   - (Đinh, Nhâm)-> Tý bắt đầu Canh
 *   - (Mậu, Quý)  -> Tý bắt đầu Nhâm
 */
function getHourCanChiName(day, month, year, hourLabel) {
  const chiInfo = parseChiFromHourLabel(hourLabel);
  if (!chiInfo) return hourLabel || '';

  try {
    const lunar = solarlunar.solar2lunar(year, month, day);
    const gzDay = lunar.gzDay || ''; // ví dụ: "Quý Mão" (tuỳ lib)
    const dayCan = gzDay.split(' ')[0]; // "Quý"
    const dayCanIndex = CAN.indexOf(dayCan);
    if (dayCanIndex === -1) {
      return `giờ ${chiInfo.chi}`;
    }
    // Nhóm can → can bắt đầu cho giờ Tý
    const startMap = {
      0: 0,
      5: 0, // Giáp,Kỷ  -> Giáp
      1: 2,
      6: 2, // Ất,Canh  -> Bính
      2: 4,
      7: 4, // Bính,Tân -> Mậu
      3: 6,
      8: 6, // Đinh,Nhâm-> Canh
      4: 8,
      9: 8, // Mậu,Quý  -> Nhâm
    };
    const startCan = startMap[dayCanIndex];
    const canIndex = (startCan + chiInfo.chiIndex) % 10;
    return `${CAN[canIndex]} ${chiInfo.chi}`;
  } catch {
    return `giờ ${chiInfo.chi}`; // fallback
  }
}

/** =====================
 *  API chính: lấy Thông tin thân chủ linh động
 * ===================== */
export function getThongTinThanChu({ day, month, year, hourLabel, isLunar, gender }) {
  if (!day || !month || !year) {
    return {
      duongLich: '—',
      amLich: '—',
      tietKhi: '—',
      gioiTinh: gender === 'nam' ? 'Nam' : 'Nữ',
      cungMenh: '—',
      banMenh: '—',
    };
  }

  let d = day,
    m = month,
    y = year;
  let dlStr = '',
    alStr = '';

  if (isLunar) {
    // Âm -> Dương
    const solar = solarlunar.lunar2solar(y, m, d, false);
    dlStr = `${solar.cDay}/${solar.cMonth}/${solar.cYear}`;
    alStr = `${d}/${m}/${y}`;
    d = solar.cDay;
    m = solar.cMonth;
    y = solar.cYear; // chuẩn hóa dùng DL cho tính TK
  } else {
    // Dương -> Âm
    const lunar = solarlunar.solar2lunar(y, m, d);
    dlStr = `${d}/${m}/${y}`;
    alStr = `${lunar.lDay}/${lunar.lMonth}/${lunar.lYear}`;
  }

  const tietKhi = getTietKhiName(d, m, y);
  const cungMenh = getCungMenh(year, gender);
  const banMenh = getNapAmByYear(year);

  // Giờ sinh (ưu tiên thêm thiên can giờ nếu suy được)
  const gioStr = hourLabel ? `${getHourCanChiName(d, m, y, hourLabel)}` : 'không rõ';

  return {
    duongLich: `${dlStr}${hourLabel ? `, ${hourLabel}` : ''}`,
    amLich: `${alStr}${hourLabel ? `, ${gioStr}` : ''}`,
    tietKhi,
    gioiTinh: gender === 'nam' ? 'Nam' : 'Nữ',
    cungMenh,
    banMenh,
  };
}
export function checkNguHanh(phoneNumber) {
  if (!phoneNumber) return null;

  // 1. Loại bỏ ký tự không phải số
  const digits = phoneNumber.replace(/\D/g, '');

  // 2. Kiểm tra độ dài phải là 9 hoặc 10 số
  if (digits.length < 9 || digits.length > 10) {
    return null;
  }

  // 3. Cộng tổng các chữ số
  let sum = digits.split('').reduce((acc, num) => acc + parseInt(num, 10), 0);

  // 4. Rút gọn còn 1 số
  while (sum > 9) {
    sum = sum
      .toString()
      .split('')
      .reduce((acc, num) => acc + parseInt(num, 10), 0);
  }

  // 5. Map số sang mệnh
  const menhMap = {
    1: 'Thủy',
    2: 'Thổ',
    3: 'Mộc',
    4: 'Mộc',
    5: 'Thổ',
    6: 'Kim',
    7: 'Kim',
    8: 'Thổ',
    9: 'Hỏa',
    0: 'Thủy',
  };

  const tuongSinhMap = {
    Mộc: 'Hỏa',
    Hỏa: 'Thổ',
    Thổ: 'Kim',
    Kim: 'Thủy',
    Thủy: 'Mộc',
  };

  const menh = menhMap[sum];
  if (!menh) return null; // phòng trường hợp không map được

  const menhts = tuongSinhMap[menh] || null;

  const css =
    menh === 'Kim' ? 'kim' : menh === 'Thủy' ? 'thuy' : menh === 'Hỏa' ? 'hoa' : menh === 'Thổ' ? 'tho' : 'moc';

  const cssts =
    menhts === 'Kim' ? 'kim' : menhts === 'Thủy' ? 'thuy' : menhts === 'Hỏa' ? 'hoa' : menhts === 'Thổ' ? 'tho' : 'moc';

  return {
    soCuoi: sum,
    menh,
    menhts, // mệnh tương sinh
    css,
    cssts,
  };
}
